<template>
    <div :class="[$store.state.layout_style, $store.state.menu_style]">
        <component v-bind:is="layout"></component>
    </div>
</template>
<script setup>
    import { computed,provide } from 'vue';
    import axios from 'axios';   
    import '@/assets/sass/app.scss';

    import { useMeta } from '@/composables/use-meta';
    import { useStore } from 'vuex';

    useMeta({ title: 'Bushman Safari Trackers' });

    const store = useStore();

    const layout = computed(() => {
        return store.getters.layout;
    });



const showMessage = (msg = '', type = 'success') => {
    const toast = Swal.mixin({
        toast: true,
        position: 'top-right',
        showConfirmButton: false,
        timer: 3000,
    });
    toast.fire({
        icon: type,
        title: msg,
        padding: '10px 20px',
        didOpen: (toast) => {
            toast.addEventListener('click', () => {
                Swal.close();
            });
        }
    });
};


const showError =  (msg = '', type = 'error') => {

const toast = Swal.mixin({
        toast: true,
        position: 'top-right',
        showConfirmButton: false,
        timer: 3000,
    });
    toast.fire({
        icon: type,
        title: msg,
        padding: '10px 20px',
    });
}

const showSuccessbox = (title = '',msg = '',icon = 'success') => {
    window.Swal.fire({
        icon: icon,
        title: title,
        text: msg,
        padding: '2em',
      });
    }



    const showErrorBox = (msg = '', type = 'error') => {
    window.Swal.fire({
        icon: 'error',
        title: 'Error',
        text: msg,
        padding: '2em',
      });
    }

    const showDeleteConfirmation = (title = '',msg = '') => {
     window.Swal.fire({
      title: title,
      text: msg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });
  }

    const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_BASE_URL
    });

    
const showConfirmation = async (title = '', msg = '', endpoint = '', action = '') => {
  if (window.Swal) {
    const result = await window.Swal.fire({
      title: title.toUpperCase(),
      text: msg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      // confirmButtonText: 'Yes ' + action
      confirmButtonText: 'Yes Proceed' 

    })
    if (result.isConfirmed) {
      try {
        await axiosInstance[action](endpoint)
        // showMessage(action + 'ed')
        showMessage('Done !')
        return { refresh: true }
      } catch (error) {
        showError(error.message)
        console.log(error)
        return { refresh: false }
      }
    } else {
      showError('Canceled')
      return { refresh: false }
    }
  }
}



const loadingIndicator = () => {
  return `
  <style>
    .progress {
      position: relative;
      height: 4px;
      display: block;
      width: 100%;
      background-color: rgb(5, 197, 255);;
      overflow: hidden;
    }
    .progress .determinate {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #26a69a;
      transition: width .3s linear;
    }
    .progress .indeterminate {
      background-color: #e7eef1;
    }
    .progress .indeterminate:before {
      content: '';
      position: absolute;
      background-color: inherit;
      top: 0;
      left: 0;
      bottom: 0;
      will-change: left, right;
      animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    }
    .progress .indeterminate:after {
      content: '';
      position: absolute;
      background-color: inherit;
      top: 0;
      left: 0;
      bottom: 0;
      will-change: left, right;
      animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
      animation-delay: 1.15s;
    }
    @keyframes indeterminate {
      0% { left: -35%; right: 100%; }
      60% { left: 100%; right: -90%; }
      100% { left: 100%; right: -90%; }
    }
    @keyframes indeterminate-short {
      0% { left: -200%; right: 100%; }
      60% { left: 107%; right: -8%; }
      100% { left: 107%; right: -8%; }
    }
  </style>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="progress">
          <div class="indeterminate"></div>
        </div>
      </div>
    </div>
  </div>`;
};

const rowShimmer = (rows = 8) => {
  let shimmerRows = '';
  for (let i = 0; i < rows; i++) {
    shimmerRows += `<div class="shimmer"></div>\n`;
  }

  return `
  <style>
    .shimmer {
      height: 20px;
      width: 100%;
      border-radius: 6px;
      position: relative;
      overflow: hidden;
      background: #e0e0e0;
      margin-bottom: 12px;
    }
    .shimmer::after {
      content: "";
      position: absolute;
      top: 0;
      left: -150px;
      width: 150px;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
      animation: shimmer 1.5s infinite;
    }
    @keyframes shimmer {
      100% { left: 100%; }
    }
  </style>
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="card p-3">
          ${shimmerRows}
        </div>
      </div>
    </div>
  </div>`;
};

const aiIndicator = () => {
  return `
  <style>
    .floating-brain {
      position: fixed;
      bottom: 20px;
      right: 20px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: white;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      cursor: pointer;
      overflow: hidden;
    }
    .floating-brain img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  </style>
  <div class="floating-brain" data-bs-toggle="modal" data-bs-target="#ai-modal">
    <img src="/ai.png" alt="AI Brain">
  </div>`;
};

const pillShimmer = () => {
  return `
  <style>
    .pill-shimmer {
      display: inline-block;
      height: 32px;
      min-width: 80px;
      border-radius: 20px;
      margin: 6px;
      position: relative;
      overflow: hidden;
      background: #e0e0e0;
    }
    .pill-shimmer::after {
      content: "";
      position: absolute;
      top: 0;
      left: -150px;
      width: 150px;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
      animation: shimmer 1.5s infinite;
    }
    @keyframes shimmer {
      100% { left: 100%; }
    }
  </style>
  <div>
    <div class="pill-shimmer"></div>
    <div class="pill-shimmer"></div>
    <div class="pill-shimmer"></div>
    <div class="pill-shimmer"></div>
    <div class="pill-shimmer"></div>
    <div class="pill-shimmer"></div>
    <div class="pill-shimmer"></div>
    <div class="pill-shimmer"></div>
  </div>
  `;
};

const loadingSpinner = () => {
  return `
  <style>
    .spinner-border {
      display: inline-block;
      width: 1.5rem;
      height: 1.5rem;
      border: 0.25em solid rgba(255, 255, 255, 0.3);
      border-right-color: #fff;
      border-radius: 50%;
      animation: spinner-border .75s linear infinite;
    }
    @keyframes spinner-border {
      to { transform: rotate(360deg); }
    }
  </style>
  <div class="spinner-border mt-1" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  `;
};




const cardShimmer = () => {
  return `
  <style>
    .section-shimmer {
      border-radius: 10px;
      margin-bottom: 30px;
      padding: 20px;
      background: #f8f9fa;
      box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    }
    .title-shimmer {
      height: 25px;
      width: 60%;
      margin: 10px auto 20px auto;
      border-radius: 6px;
      position: relative;
      overflow: hidden;
      background: #e0e0e0;
    }
    .card-shimmer {
      height: 90px;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      background: #e0e0e0;
      box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    }
    .title-shimmer::after,
    .card-shimmer::after {
      content: "";
      position: absolute;
      top: 0;
      left: -150px;
      width: 150px;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
      animation: shimmer 1.5s infinite;
    }
    @keyframes shimmer {
      100% { left: 100%; }
    }
  </style>

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="section-shimmer text-center">
          <div class="title-shimmer"></div>
          <div class="row mt-3">
            <div class="col-md-6"><div class="card-shimmer"></div></div>
            <div class="col-md-6"><div class="card-shimmer"></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  `;
};

const pleaseWait = () => {
  return `
  <style>
    .please-wait {
      font-size: 22px;
      font-weight: 600;
      color: #6c757d;
      text-align: center;
    }
    .please-wait span {
      display: inline-block;
      width: 1.5em;
      text-align: left;
    }
    .please-wait span::after {
      content: "";
      animation: dots 1.5s infinite;
    }
    @keyframes dots {
      0% { content: ""; }
      20% { content: "."; }
      40% { content: ".."; }
      60% { content: "..."; }
      80% { content: "...."; }
      100% { content: ""; }
    }
  </style>

  <div class="please-wait text-info" style="font-style: italic;">
    Please wait <span></span>
  </div>
  `;
};





// table printout starts
const printReport = (dataArray, reportTitle = "Report") => {
    const formatCell = (value, key) => {
        if (typeof value === 'number') return `<span class="number">${value}</span>`;
        return value !== null && value !== undefined ? value : '';
    };

    if (!Array.isArray(dataArray) || dataArray.length === 0) {
        console.error("No data provided or empty array!");
        return;
    }

    const excludeKeys = ['actions', 'status'];
    const headers = Object.keys(dataArray[0]).filter(key => !excludeKeys.includes(key));
    const printWindow = window.open('', '_blank');

    printWindow.document.write(`
        <html>
            <head>
                <title>Print ${reportTitle}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 10px; }
                    table { width: 100%; border-collapse: collapse; table-layout: fixed; }
                    th, td { 
                        border: 1px solid #ccc; 
                        padding: 4px; 
                        text-align: left; 
                        font-size: 15px; 
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    th { background-color: #f1f1f1; }
                    td.number { text-align: right; }
                    @media print { body { zoom: 90%; } }
                </style>
            </head>
            <body>
                <h2>${reportTitle}</h2>
                <div style="overflow-x:auto;">
                    <table>
                        <thead><tr>${headers.map(key => `<th>${key}</th>`).join('')}</tr></thead>
                        <tbody>${dataArray.map(item => `
                            <tr>${headers.map(key => `<td>${formatCell(item[key], key)}</td>`).join('')}</tr>
                        `).join('')}</tbody>
                    </table>
                </div>
                <p>Generated on: ${new Date().toLocaleString()}</p>
            </body>
        </html>
    `);
    printWindow.document.close();
    printWindow.print();
};


//27 feb 2026
const graphShimmer = () => {
  return `
  <style>
    .graph-shimmer {
      display: flex;
      align-items: flex-end;
      gap: 6px;
      height: 200px;
      margin: 20px 0;
    }
    .graph-shimmer .bar {
      flex: 1;
      border-radius: 4px 4px 0 0;
      background: #e0e0e0;
      position: relative;
      overflow: hidden;
    }
    .graph-shimmer .bar::after {
      content: "";
      position: absolute;
      top: 0;
      left: -150px;
      width: 150px;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
      animation: shimmer 1.5s infinite;
    }
    @keyframes shimmer {
      100% { left: 100%; }
    }
  </style>
  <div class="graph-shimmer">
    <div class="bar" style="height: 30%;"></div>
    <div class="bar" style="height: 50%;"></div>
    <div class="bar" style="height: 70%;"></div>
    <div class="bar" style="height: 40%;"></div>
    <div class="bar" style="height: 20%;"></div>
  </div>
  `;
};

const now = new Date();
const nowDate = now.toISOString().slice(0, 10); 
const nowTime = now.toTimeString().slice(0, 8); 


// table printout ends
const recordLog = async (user_id,user_name,action,type,activity_id,date,quantity) => {
      try {
        const formData = {
          user_id: user_id,
          user_name: user_name,
          action: action,
          type: type,
          activity_id: activity_id,
          date: date ?? nowDate,
          time: nowTime,
          quantity:quantity
        };
        
        // Send POST request to create new activity
        const response = await axios.post('https://construction.trustdigital.space/api/v1/activity-logs', formData);
        
        if (response.data && response.data.status === "success") {
            console.log('log:OK');
        } else {
           console.log('log:FAIL');
        }
      } catch (error) {
        console.log('log:Error',error);
      } 
    };
// recording log starts

// recording log ends 

// notification starts
  const whatsappNotification = async (phone,sender,action,message) => {
  const recipientPhone = phone;
  const endpoint = 'https://graph.facebook.com/v22.0/721816217672551/messages';
  const accessToken = 'EAAXZAN9ZAW4VoBOZBhohedZA7pfKZBfzMghywTumPW7yFY0ZAI7u6Kh9DFtai4usEnmKsOnMZBYisZAQ0ojZBtEpDC72XXNyf6qFmtFtTCX61hv3I2eZCdZAevM9ahsDXGcIhT8stZAoTGstgOsujK4G1pxcSGqwFxiucZBcLr8HUoRxTLlB0IdVlLLlRGQ7n831T93WGUQZDZD';

  const requestData = {
    "messaging_product": "whatsapp",
    "recipient_type": "individual",
    "to": recipientPhone,
    "type": "template",
    "template": {
        "name": "notifier",
        "language": {
            "code": "en"
        },
        "components": [
            {
                "type": "body",
                "parameters": [
                    {
                        "type": "text",
                        "text": sender // Replaced "Engineer" with sender variable
                    },
                    {
                        "type": "text",
                        "text": action // Replaced first "check" with action variable
                    },

                     {
                        "type": "text",
                        "text": message // Replaced first "check" with action variable
                    },
                ]
            }
        ]
    }
};
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    });
    const data = await response.json();
  } catch (error) {
    console.error('Error:', error);
  }
};

  const whatsappNotification2 = async (phone,sender,action,message,next_checker) => {
    console.log('sending ...');
  const recipientPhone = phone;
  const endpoint = 'https://graph.facebook.com/v22.0/721816217672551/messages';
  const accessToken = 'EAAXZAN9ZAW4VoBOZBhohedZA7pfKZBfzMghywTumPW7yFY0ZAI7u6Kh9DFtai4usEnmKsOnMZBYisZAQ0ojZBtEpDC72XXNyf6qFmtFtTCX61hv3I2eZCdZAevM9ahsDXGcIhT8stZAoTGstgOsujK4G1pxcSGqwFxiucZBcLr8HUoRxTLlB0IdVlLLlRGQ7n831T93WGUQZDZD';

  const requestData = {
    "messaging_product": "whatsapp",
    "recipient_type": "individual",
    "to": recipientPhone,
    "type": "template",
    "template": {
        "name": "copex_lpo",
        "language": {
            "code": "en"
        },
        "components": [
            {
                "type": "body",
                "parameters": [
                    {
                        "type": "text",
                        "text": sender // Replaced "Engineer" with sender variable
                    },
                    {
                        "type": "text",
                        "text": action // Replaced first "check" with action variable
                    },

                      {
                        "type": "text",
                        "text": next_checker 
                    },

                     {
                        "type": "text",
                        "text": message 
                    },

                    

                ]
            }
        ]
    }
};
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    });
    const data = await response.json();
    console.log('sent to ',sender);
  } catch (error) {
    console.error('Error:', error);
  }
};
// notification ends

// ai answer starts
const aiAnswer = async (message, retries = 3, delay = 2000) => {
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const response = await axios.post(
        'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=AIzaSyAuGP7TxA6KPTmzSV3IF8WhTfzIKUfygHU',
        {
          contents: [
            {
              role: 'user',
              parts: [{ text: message }]
            }
          ]
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );

      const candidate = response.data.candidates?.[0];
      const result = candidate?.content?.parts?.[0]?.text;
      return result || 'No answer received.';
    } catch (error) {
      const isOverloaded =
        error.response?.status === 503 ||
        error.response?.data?.error?.message?.includes('overloaded');

      if (isOverloaded && attempt < retries - 1) {
        await new Promise((res) => setTimeout(res, delay));
        continue;
      }

      console.error(error);
      return 'Failed to get an answer. Try again later.';
    }
  }
};

const aiAnswer2 = async (message, retries = 3, delay = 2000) => {
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const response = await axios.post(
        'https://openrouter.ai/api/v1/chat/completions',
        {
          model: 'mistralai/mistral-7b-instruct:free',
          messages: [
            {
              role: 'user',
              content: message
            }
          ]
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer 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'
          }
        }
      );

      return response.data.choices?.[0]?.message?.content || 'No answer received.';
    } catch (error) {
      const isOverloaded =
        error.response?.status === 503 ||
        error.response?.data?.error?.message?.includes('overloaded');

      if (isOverloaded && attempt < retries - 1) {
        await new Promise((res) => setTimeout(res, delay));
        continue;
      }

      console.error(error);
      return 'Failed to get an answer. Try again later.';
    }
  }
};

const deepseek = async (message, retries = 3, delay = 2000) => {
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const response = await axios.post(
        'https://openrouter.ai/api/v1/chat/completions',
        {
          model: 'tngtech/deepseek-r1t-chimera:free',
          messages: [
            {
              role: 'system',
              content: 'Respond concisely and avoid deep reasoning or long explanations. Keep answers short and fast.'
            },
            {
              role: 'user',
              content: message
            }
          ]
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer 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'
          }
        }
      );

      return response.data.choices?.[0]?.message?.content || 'No answer received.';
    } catch (error) {
      const isOverloaded =
        error.response?.status === 503 ||
        error.response?.data?.error?.message?.includes('overloaded');

      if (isOverloaded && attempt < retries - 1) {
        await new Promise((res) => setTimeout(res, delay));
        continue;
      }

      console.error(error);
      return 'Failed to get an answer. Try again later.';
    }
  }
};


// ai answer ends

//table shimmer
const tableShimmer = (rows = 10, cols = 7) => {
  let shimmerCols = '';
  for (let c = 0; c < cols; c++) {
    shimmerCols += `<td><div class="shimmer"></div></td>`;
  }

  let shimmerRows = '';
  for (let r = 0; r < rows; r++) {
    shimmerRows += `<tr>${shimmerCols}</tr>`;
  }

  return `
  <style>
    .shimmer {
      height: 16px;
      width: 100%;
      border-radius: 4px;
      position: relative;
      overflow: hidden;
      background: #e0e0e0;
    }
    .shimmer::after {
      content: "";
      position: absolute;
      top: 0;
      left: -150px;
      width: 150px;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
      animation: shimmer 1.5s infinite;
    }
    @keyframes shimmer {
      100% {
        left: 100%;
      }
    }
  </style>
  <div class="table-responsive">
    <table class="table table-bordered">
      <thead>
        <tr>
          ${Array(cols).fill('<th><div class="shimmer"></div></th>').join('')}
        </tr>
      </thead>
      <tbody>
        ${shimmerRows}
      </tbody>
    </table>
  </div>`;
};

const formatDate = (date) => {
  if (!date) return '-- -- --'
  const d = new Date(date)
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = String(d.getFullYear()).slice(-2)
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  return `${day}/${month}/${year} ${hours}:${minutes}`
}


//25 august 2025
const formatNumber = (value) => {
  return new Intl.NumberFormat('en-US', { 
    minimumFractionDigits: 1, 
    maximumFractionDigits: 1 
  }).format(value) + '/=';
};


const enforceMax = (value, max) => {
  if (value > max) {
    showError("Only " + max + ' allowed!')
    return max
  }
  return value
}

const whatsappAlert = async (message, message_id,receiver) => {
  const url = "https://graph.facebook.com/v22.0/721816217672551/messages";
  const token = "EAAXZAN9ZAW4VoBOZBhohedZA7pfKZBfzMghywTumPW7yFY0ZAI7u6Kh9DFtai4usEnmKsOnMZBYisZAQ0ojZBtEpDC72XXNyf6qFmtFtTCX61hv3I2eZCdZAevM9ahsDXGcIhT8stZAoTGstgOsujK4G1pxcSGqwFxiucZBcLr8HUoRxTLlB0IdVlLLlRGQ7n831T93WGUQZDZD";

  await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({
      messaging_product: "whatsapp",
      recipient_type: "individual",
      to: receiver,
      context: { message_id },
      type: "text",
      text: { preview_url: false, body: message },
    }),
  });
};

// map shimmer 
const mapShimmer = () => {
  return `
  <style>
    .map-shimmer {
      height: 600px;
      width: 100%;
      border-radius: 6px;
      position: relative;
      overflow: hidden;
      background: #e0e0e0;
    }
    .map-shimmer::after {
      content: "";
      position: absolute;
      top: 0;
      left: -200px;
      width: 200px;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255,255,255,0.6),
        transparent
      );
      animation: mapShimmer 1.5s infinite;
    }
    @keyframes mapShimmer {
      100% {
        left: 100%;
      }
    }
  </style>

  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="card p-2">
          <div class="map-shimmer"></div>
        </div>
      </div>
    </div>
  </div>
  `
}



const printApprovalReport = async (items, route, approvalGroup, formatNumber, statusFilter) => {
  try {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    // Calculate total cost
    const totalCost = items.reduce((sum, item) => {
      const cost = typeof item.cost === 'string' ? parseFloat(item.cost.replace(/,/g, '')) : item.cost;
      return sum + (isNaN(cost) ? 0 : cost);
    }, 0);

    // Determine heading based on status filter
    let reportHeading = '';
    if (statusFilter === 'status_id=3') {
      reportHeading = 'APPROVED REQUISITIONS';
    } else if (statusFilter === 'status_id=2') {
      reportHeading = 'UNAPPROVED REQUISITIONS';
    } else if (statusFilter === 'status_id=16') {
      reportHeading = 'PAID REQUISITIONS';
    } else if (route.params.group_id === '1') {
      reportHeading = 'LOCAL PURCHASE ORDERS';
    } else if (route.params.group_id === '4') {
      reportHeading = 'PAYMENT VOUCHERS';
    } else {
      reportHeading = (approvalGroup?.group?.toUpperCase() || 'REQUISITIONS');
    }

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<style>
  body { font-family: 'Courier New', monospace; margin: 20px; font-size: 8px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; font-size: 9px; }
  .company-title h1 { font-size: 14px; margin: 5px 0; }
  .title { text-align: center; font-size: 12px; margin: 8px 0; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 9px; }
  th, td { border: 1px solid #000; padding: 3px 4px; }
  th { background-color: #f0f0f0; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .badge { padding: 2px 5px; border-radius: 2px; font-size: 8px; display: inline-block; }
  .badge-success { background-color: #28a745; color: white; }
  .badge-warning { background-color: #ffc107; color: black; }
  .badge-danger { background-color: #dc3545; color: white; }
  .badge-info { background-color: #17a2b8; color: white; }
  hr { border: 0; border-top: 1px solid #000; margin: 8px 0; }
  @media print { 
    body { margin: 5mm; } 
    table { page-break-inside: auto; }
    tr { page-break-inside: avoid; page-break-after: auto; }
  }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr>

<div class="title text-style">
  ${reportHeading} REPORT
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>S/No.</th>
      <th>Order_no</th>
      <th>Purpose</th>
      <th>Type</th>
      <th>Requester</th>
      <th>Project</th>
      <th>Status</th>
      <th>Date</th>
      <th>Awaits</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.approval || 'N/A'}</td>
      <td>${item.purpose || 'N/A'}</td>
      <td>${item.type || 'N/A'}</td>
      <td>${item.requester || 'N/A'}</td>
      <td>${item.project || 'N/A'}</td>
      <td class="text-center">${item.status?.name || 'N/A'}</span></td>
      <td>${item.date || 'N/A'}</td>
      <td>${item.awaits || 'N/A'}</td>
      <td class="text-right">${item.cost || '0'}</td>
    </tr>
    `).join('')}
    <tr style="font-weight: bold;">
      <td colspan="9" class="text-right"><strong>TOTAL:</strong></td>
      <td class="text-right"><strong>${formatNumber(totalCost)}</strong></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 7px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};

const printStores = async (categoryFilter) => {
  try {
const response = await axiosInstance.get(`get-stores?category=${categoryFilter}`)
const items = response.data

const totalCost = items.reduce((sum, item) => {
  return sum + Number(item.cost || 0)
}, 0)

let reportHeading = ''
if (categoryFilter === 'all') {
  reportHeading = 'ALL STORES REPORT'
} else if (categoryFilter === 'main') {
  reportHeading = 'MAIN STORES REPORT'
} else if (categoryFilter === 'substore') {
  reportHeading = 'SUB STORES REPORT'
}

    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    
    const printContent = `
<!DOCTYPE html>
<html>
<head>
<style>
  body { font-family: 'Courier New', monospace; margin: 20px; font-size: 8px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; font-size: 9px; }
  .company-title h1 { font-size: 14px; margin: 5px 0; }
  .title { text-align: center; font-size: 12px; margin: 8px 0; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 9px; }
  th, td { border: 1px solid #000; padding: 3px 4px; }
  th { background-color: #f0f0f0; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .badge { padding: 2px 5px; border-radius: 2px; font-size: 8px; display: inline-block; }
  .badge-success { background-color: #28a745; color: white; }
  .badge-warning { background-color: #ffc107; color: black; }
  .badge-danger { background-color: #dc3545; color: white; }
  .badge-info { background-color: #17a2b8; color: white; }
  hr { border: 0; border-top: 1px solid #000; margin: 8px 0; }
  @media print { 
    body { margin: 5mm; } 
    table { page-break-inside: auto; }
    tr { page-break-inside: avoid; page-break-after: auto; }
  }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr>

<div class="title text-style">
  ${reportHeading} 
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>S/No.</th>
      <th>Name</th>
      <th>Type</th>
      <th class="text-right">Stock Value</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.name || 'N/A'}</td>
      <td>${item.type || 'N/A'}</td>
      <td class="text-right">${formatNumber(item.cost) || '0'}</td>
    </tr>
    `).join('')}
    <tr style="font-weight: bold;">
      <td colspan="3" class="text-right"><strong>TOTAL:</strong></td>
      <td class="text-right"><strong>${formatNumber(totalCost)}</strong></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 7px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};


const printRemoteAttendance = async (date) => {
  try {
const response = await axiosInstance.get(`geo-location-attendances?date=${date}`)
const items = response.data




    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    
    const printContent = `
<!DOCTYPE html>
<html>
<head>
<style>
  body { font-family: 'Courier New', monospace; margin: 20px; font-size: 8px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; font-size: 9px; }
  .company-title h1 { font-size: 14px; margin: 5px 0; }
  .title { text-align: center; font-size: 12px; margin: 8px 0; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 9px; }
  th, td { border: 1px solid #000; padding: 3px 4px; }
  th { background-color: #f0f0f0; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .badge { padding: 2px 5px; border-radius: 2px; font-size: 8px; display: inline-block; }
  .badge-success { background-color: #28a745; color: white; }
  .badge-warning { background-color: #ffc107; color: black; }
  .badge-danger { background-color: #dc3545; color: white; }
  .badge-info { background-color: #17a2b8; color: white; }
  hr { border: 0; border-top: 1px solid #000; margin: 8px 0; }
  @media print { 
    body { margin: 5mm; } 
    table { page-break-inside: auto; }
    tr { page-break-inside: avoid; page-break-after: auto; }
  }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr>

<div class="title text-style">
  REMOTE ATTENDANCE REPORT 
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>S/No.</th>
      <th>Employee</th>
      <th>Role</th>
      <th>Email</th>
      <th>Phone</th>
      <th>Report Location</th>
      <th>Time</th>
      <th>Site</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.user.name || 'N/A'}</td>
      <td>${item.user.role_data.name || 'N/A'}</td>
      <td>${item.user.email || 'N/A'}</td>
      <td>${item.user.phone || 'N/A'}</td>
      <td>${item.location || 'N/A'}</td>
      <td>${formatDate(item.created_at) || 'N/A'}</td>
      <td>${item?.store?.project?.short_name || 'N/A'}</td>
    </tr>
    `).join('')}

  </tbody>
</table>

<div style="margin-top: 15px; font-size: 7px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};


const printSiteLabourAttendance = async (date) => {
  try {
const response = await axiosInstance.get(`labour-attendants?date=${date}`)
const items = response.data

const totalCost = items.reduce((sum, item) => {
  return sum + Number(item.labour_type.rate || 0)
}, 0)


    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    
    const printContent = `
<!DOCTYPE html>
<html>
<head>
<style>
  body { font-family: 'Courier New', monospace; margin: 20px; font-size: 8px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; font-size: 9px; }
  .company-title h1 { font-size: 14px; margin: 5px 0; }
  .title { text-align: center; font-size: 12px; margin: 8px 0; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 9px; }
  th, td { border: 1px solid #000; padding: 3px 4px; }
  th { background-color: #f0f0f0; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .badge { padding: 2px 5px; border-radius: 2px; font-size: 8px; display: inline-block; }
  .badge-success { background-color: #28a745; color: white; }
  .badge-warning { background-color: #ffc107; color: black; }
  .badge-danger { background-color: #dc3545; color: white; }
  .badge-info { background-color: #17a2b8; color: white; }
  hr { border: 0; border-top: 1px solid #000; margin: 8px 0; }
  @media print { 
    body { margin: 5mm; } 
    table { page-break-inside: auto; }
    tr { page-break-inside: avoid; page-break-after: auto; }
  }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr>

<div class="title text-style">
  REMOTE ATTENDANCE REPORT 
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>S/No.</th>
      <th>Labour</th>
      <th>Type</th>
      <th>Task</th>
      <th>Time Reported</th>
      <th>Site</th>
      <th>Task Status</th>
      <th>Cost Per Day</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.labour_name || 'N/A'}</td>
      <td>${item.labour_type.name || 'N/A'}</td>
      <td>${item.task || 'N/A'}</td>
      <td>${item.reporting_time || 'N/A'}</td>
      <td>${item.project.short_name || 'N/A'}</td>
      <td>${item.status.name || 'N/A'}</td>
      <td class="text-right">${ formatNumber(item.labour_type.rate) || 'N/A'}</td>
    </tr>
    `).join('')}
    <tr style="font-weight: bold;">
      <td colspan="7" class="text-right"><strong>TOTAL COST :</strong></td>
      <td class="text-right"><strong>${formatNumber(totalCost)}</strong></td>
    </tr>

  </tbody>
</table>



<div style="margin-top: 15px; font-size: 7px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};




const printStoreItems = async (store_id,store) => {
  try {
const response = await axiosInstance.get(`get-store-items?store_id=${store_id}`)
const items = response.data

const totalCost = items.reduce((sum, item) => {
  return sum + Number(item.balance_quantity * item.rate)
}, 0)



    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    
    const printContent = `
<!DOCTYPE html>
<html>
<head>
<style>
  body { font-family: 'Courier New', monospace; margin: 20px; font-size: 8px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; font-size: 9px; }
  .company-title h1 { font-size: 14px; margin: 5px 0; }
  .title { text-align: center; font-size: 12px; margin: 8px 0; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 9px; }
  th, td { border: 1px solid #000; padding: 3px 4px; }
  th { background-color: #f0f0f0; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .badge { padding: 2px 5px; border-radius: 2px; font-size: 8px; display: inline-block; }
  .badge-success { background-color: #28a745; color: white; }
  .badge-warning { background-color: #ffc107; color: black; }
  .badge-danger { background-color: #dc3545; color: white; }
  .badge-info { background-color: #17a2b8; color: white; }
  hr { border: 0; border-top: 1px solid #000; margin: 8px 0; }
  @media print { 
    body { margin: 5mm; } 
    table { page-break-inside: auto; }
    tr { page-break-inside: avoid; page-break-after: auto; }
  }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr>

<div class="title text-style">
  ${store} 
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>S/No.</th>
      <th>Item</th>
      <th>Category</th>
      <th>Condition</th>
      <th>Quantity</th>
      <th>Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.name || 'N/A'}</td>
      <td>${item.category_name || 'N/A'}</td>
      <td>${item.condition || 'N/A'}</td>
      <td>${item.balance_quantity || 'N/A'}</td>
      <td>${ formatNumber(item.rate) || 'N/A'}</td>
      <td class="text-right">${formatNumber(item.balance_quantity * item.rate ) || '0'}</td>
    </tr>
    `).join('')}
    <tr style="font-weight: bold;">
      <td colspan="6" class="text-right"><strong>TOTAL:</strong></td>
      <td class="text-right"><strong>${formatNumber(totalCost)}</strong></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 7px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};


// 17 jan 2026
const printEmployees = async (items,gender) => {

  try {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Employees Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; font-size: 12px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
${gender.toUpperCase()} EMPLOYEES LIST REPORT
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Full Name</th>
      <th>Date of Birth</th>
      <th>Gender</th>
      <th>Marital Status</th>
      <th>Age</th>
      <th>Department</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((employee, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${employee.full_name || 'N/A'}</td>
      <td>${employee.date_of_birth || 'N/A'}</td>
      <td>${employee.gender || 'N/A'}</td>
      <td>${employee.marital_status || 'N/A'}</td>
      <td class="text-center">${employee.age || 'N/A'}</td>
      <td>${employee.department || 'N/A'}</td>
      <td class="text-center">${employee.status.name || 'N/A'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="8" class="text-center"><strong>TOTAL EMPLOYEES: ${items.length}</strong></td>
    </tr>
  </tbody>
</table>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    console.error(`Failed to print report: ${error.message}`);
  }
};

const printLabourTypes = async () => {

  try {
   const response = await axiosInstance.get('labour-types')
   const  items = response.data
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Employees Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; font-size: 12px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
LABOUR TYPES LIST
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>SNo.</th>
      <th>Labour </th>
      <th>Rate</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((data, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${data.name || 'N/A'}</td>
      <td>${formatNumber(data.rate) || 'N/A'}</td>
      <td>${data.status.name|| 'N/A'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="8" class="text-center"><strong>TOTAL LABOUR TYPES AND RATES : ${items.length}</strong></td>
    </tr>
  </tbody>
</table>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    console.error(`Failed to print report: ${error.message}`);
  }
};


const printLabourRequests = async(status,title) =>{
    try {
   const response = await axiosInstance.get(`labour-requests?status_id=${status}`)
   const  items = response.data
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Employees Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; font-size: 12px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
 ${title.toUpperCase()} LABOUR REQUEST REPORT
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>SNo.</th>
      <th>Req_ID</th>
      <th>Requester</th>
      <th>Project </th>
      <th>Total Labours </th>
      <th>Working Days</th>
      <th>Cost </th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((data, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${data.id || 'N/A'}</td>
      <td>${data.requester_name || 'N/A'}</td>
      <td>${data.project || 'N/A'}</td>
      <td>${data.total_labours || 'N/A'}</td>
      <td>${data.working_days || 'N/A'}</td>
      <td>${formatNumber(data.total_cost) || 'N/A'}</td>
      <td>${data.status_name|| 'N/A'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="8" class="text-center"><strong>TOTAL LABOUR REQUESTS : ${items.length}</strong></td>
    </tr>
  </tbody>
</table>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    console.error(`Failed to print report: ${error.message}`);
  }
}

const printApprovals = async (group_id,status_id ,title) => {
  try {
    const response = await axiosInstance.get(`approval-summary?approval_group_id=${group_id}&status_id=${status_id}`)
    const items = response.data
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    // Calculate total cost
const totalCost = items.reduce((sum, item) => {
  return sum + Number(item.total_amount || 0)
}, 0)


    const printContent = `
<!DOCTYPE html>
<html>
<head>
<style>
  body { font-family: 'Courier New', monospace; margin: 20px; font-size: 8px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; font-size: 9px; }
  .company-title h1 { font-size: 14px; margin: 5px 0; }
  .title { text-align: center; font-size: 12px; margin: 8px 0; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 9px; }
  th, td { border: 1px solid #000; padding: 3px 4px; }
  th { background-color: #f0f0f0; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .badge { padding: 2px 5px; border-radius: 2px; font-size: 8px; display: inline-block; }
  .badge-success { background-color: #28a745; color: white; }
  .badge-warning { background-color: #ffc107; color: black; }
  .badge-danger { background-color: #dc3545; color: white; }
  .badge-info { background-color: #17a2b8; color: white; }
  hr { border: 0; border-top: 1px solid #000; margin: 8px 0; }
  @media print { 
    body { margin: 5mm; } 
    table { page-break-inside: auto; }
    tr { page-break-inside: avoid; page-break-after: auto; }
  }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr>

<div class="title text-style">
  ${title} REPORT
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>S/No.</th>
      <th>Order_no</th>
      <th>Purpose</th>
      <th>Type</th>
      <th>Requester</th>
      <th>Project</th>
      <th>Status</th>
      <th>Date</th>
      <th>Total Items</th>
      <th>Awaits</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.approval_id || 'N/A'}</td>
      <td>${item.approval_group_name || 'N/A'}</td>
      <td>${item.requisition_type || 'N/A'}</td>
      <td>${item.requester_name || 'N/A'}</td>
      <td>${item.project || 'N/A'}</td>
      <td class="text-center">${item.status_name || 'N/A'}</span></td>
      <td>${formatDate(item.date_requested) || 'N/A'}</td>
      <td>${item.awaits?.total_items || 'no one'}</td>
      <td>${item.awaits?.name || 'no one'}</td>
      <td class="text-right">${ formatNumber(item.total_amount) || '0'}</td>
    </tr>
    `).join('')}
    <tr style="font-weight: bold;">
      <td colspan="10" class="text-right"><strong>TOTAL:</strong></td>
      <td class="text-right"><strong>${formatNumber(totalCost)}</strong></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 7px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};

const printReportMeeting = async (meetingData) => {
  try {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Meeting Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  .meeting-info { margin: 20px 0; }
  .meeting-info div { margin: 5px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 20px; page-break-inside: auto; }
  thead { display: table-header-group; }
  tr { page-break-inside: avoid; page-break-after: auto; }
  th, td { border: 0.5px solid #000; padding: 6px; text-align: left; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-center { text-align: center; }
  .section-title { font-weight: bold; font-size: 16px; margin-top: 20px; margin-bottom: 10px; page-break-after: avoid; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 10px 0; }
  @media print { 
    body { margin: 10mm; }
    table { page-break-inside: auto; }
    tr { page-break-inside: avoid; page-break-after: auto; }
    thead { display: table-header-group; }
  }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  MEETING REPORT
</div>

<hr>



<div class="text-style" style="margin: 20px 0; display: flex; justify-content: space-between; gap: 20px;">
  <div style="flex: 1;">
    <p><strong>Meeting Name:</strong> ${meetingData.name || 'N/A'}</p>
    <p><strong>Date::</strong> ${meetingData.date || 'N/A'}</p>
    <p><strong>Time::</strong> ${meetingData.meeting_time || 'N/A'}</p>
  </div>
  <div style="flex: 1;">
    <p><strong>Duration:</strong>  ${meetingData.duration || 'N/A'}</p>
    <p><strong>Location:</strong> ${meetingData.location || 'N/A'}</p>
    <p><strong>Organizer:</strong> ${meetingData.organizer?.name || 'N/A'}</p>
  </div>
</div>


<div class="section-title">MEETING AGENDA</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Description</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${meetingData.agendas?.map((agenda, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${agenda.description || 'N/A'}</td>
      <td>${agenda.status?.name || 'N/A'}</td>
    </tr>
    `).join('') || '<tr><td colspan="3" class="text-center">No agenda items</td></tr>'}
  </tbody>
</table>

<div class="section-title">MEETING MINUTES</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Description</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${meetingData.minutes?.map((minute, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${minute.description || 'N/A'}</td>
      <td>${minute.status?.name || 'N/A'}</td>
    </tr>
    `).join('') || '<tr><td colspan="3" class="text-center">No minutes</td></tr>'}
  </tbody>
</table>


<div class="section-title">MEETING ATTENDEES</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Name</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${meetingData.attendees?.map((attendee, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${attendee.name || attendee.user?.name || 'N/A'}</td>
      <td>${attendee.status?.name || 'N/A'}</td>
    </tr>
    `).join('') || '<tr><td colspan="3" class="text-center">No attendees</td></tr>'}
  </tbody>
</table>

<h3 class="text-center"></h3>
<table class="signatures" style="margin-top: 10px;">
  <tbody>

    <!-- Added row (ONLY this is new) -->
    <tr>
  <td class="text-center text-dark" style="border: none !important;">Prepared By</td>
  <td class="text-center text-dark" style="border: none !important;">Approved By</td>
</tr>

    <!-- Your original row (UNCHANGED) -->
    <tr>
      <td style="border-bottom:1px solid #000;border-top:1px solid #fff;border-right:1px solid #fff;border-left:1px solid #fff;" class="text-center text-success">
        ${meetingData.issuer?.name || ' Valentine '}
      </td>
      <td style="border-bottom:1px solid #000;border-top:1px solid #fff;border-right:1px solid #fff;border-left:1px solid #fff;" class="text-center text-danger">
        ${meetingData.approval?.name || ' no one '}
      </td>
    </tr>

  </tbody>

  <!-- Your footer stays exactly as is -->
  <tfooter>
    <tr>
      <th style="border-bottom:1px solid #fff;border-top:1px solid #fff;border-right:55px solid #fff;border-left:1px solid #fff;" class="text-center">
        ${meetingData.issuer?.role_data?.name || 'HR'}
      </th>
      <th style="border-bottom:1px solid #fff;border-top:1px solid #fff;border-right:55px solid #fff;border-left:1px solid #fff;" class="text-center">
        ${meetingData.approval?.role_data?.name || 'DIRECTOR'}
      </th>
    </tr>
  </tfooter>
</table>
<div style="margin-top: 15px; font-size: 7px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};


const printAllMeetingsReport = async (categoryFilter) => {
  try {
    const response = await axiosInstance.get(`meeting-report?category=${categoryFilter}`);
    const data = response.data;
    const meetings = data.meetings || [];

    let reportHeading = '';
    if (categoryFilter === 'all') {
      reportHeading = 'ALL MEETINGS REPORT';
    } else if (categoryFilter === 'scheduled') {
      reportHeading = 'SCHEDULED MEETINGS REPORT';
    } else if (categoryFilter === 'upcoming') {
      reportHeading = 'UPCOMING MEETINGS REPORT';
    } else if (categoryFilter === 'history') {
      reportHeading = 'HISTORY MEETINGS REPORT';
    } else {
      reportHeading = 'MEETINGS REPORT';
    }



    // Create iframe (safe for printing)
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Meetings Report</title>
<style>
  @page {
    margin: 5mm;
  }

  @media print {
    body {
      margin: 0;
    }

    .meeting-section {
      page-break-inside: auto;
      margin-top: 6px;
    }

    table {
      margin-top: 4px;
    }

    hr {
      margin: 4px 0;
    }
  }

  body { 
    font-family: 'Courier New', monospace; 
    font-size: 11px; 
  }

  .company-title { text-align: center; }
  .company-title h1 { font-size: 18px; margin: 4px 0; }
  .title { text-align: center; font-size: 14px; margin: 6px 0; font-weight: bold; }

  table { 
    width: 100%; 
    border-collapse: collapse; 
    font-size: 11px; 
  }

  th, td { 
    border: 1px solid #000; 
    padding: 3px; 
  }

  th { 
    background-color: #f0f0f0; 
  }

  .text-center { text-align: center; }

  .meeting-header { 
    background-color: #e9ecef; 
    font-weight: bold; 
    padding: 4px; 
    font-size: 13px;
  }

  .sub-table { 
    margin: 8px 0; 
  }
</style>
</head>
<body>

<div class="company-title">
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
</div>

<hr>

<div class="title">
  ${reportHeading}
</div>

<hr>

${meetings.map((meeting) => `
<div class="meeting-section">

  <div class="meeting-header text-center">
    MEETING: ${(meeting.name || 'N/A').toUpperCase()}
  </div>

  <table style="margin-bottom: 8px;">
    <tr>
      <td><strong>Date:</strong></td>
      <td>${meeting.date || 'N/A'}</td>
      <td><strong>Time:</strong></td>
      <td>${meeting.meeting_time || 'N/A'}</td>
    </tr>
    <tr>
      <td><strong>Duration:</strong></td>
      <td>${meeting.duration || 'N/A'}</td>
      <td><strong>Location:</strong></td>
      <td>${meeting.location || 'N/A'}</td>
    </tr>
    <tr>
      <td><strong>Organizer:</strong></td>
      <td colspan="3">${meeting.organizer?.name || 'N/A'}</td>
    </tr>
  </table>

  <strong>AGENDAS:</strong>
  <table class="sub-table">
    <thead>
      <tr>
        <th>No.</th>
        <th>Description</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      ${
        meeting.agendas?.length
          ? meeting.agendas.map((agenda, idx) => `
            <tr>
              <td>${idx + 1}</td>
              <td>${agenda.description || 'N/A'}</td>
              <td>${agenda.status?.name || 'N/A'}</td>
            </tr>
          `).join('')
          : `<tr><td colspan="3" class="text-center">No agenda items</td></tr>`
      }
    </tbody>
  </table>

  <strong>MINUTES:</strong>
  <table class="sub-table">
    <thead>
      <tr>
        <th>No.</th>
        <th>Description</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      ${
        meeting.minutes?.length
          ? meeting.minutes.map((minute, idx) => `
            <tr>
              <td>${idx + 1}</td>
              <td>${minute.description || 'N/A'}</td>
              <td>${minute.status?.name || 'N/A'}</td>
            </tr>
          `).join('')
          : `<tr><td colspan="3" class="text-center">No minutes</td></tr>`
      }
    </tbody>
  </table>

  <strong>ATTENDEES:</strong>
  <table class="sub-table">
    <thead>
      <tr>
        <th>No.</th>
        <th>Name</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      ${
        meeting.attendees?.length
          ? meeting.attendees.map((attendee, idx) => `
            <tr>
              <td>${idx + 1}</td>
              <td>${attendee.name || 'N/A'}</td>
              <td>${attendee.status?.name || 'N/A'}</td>
            </tr>
          `).join('')
          : `<tr><td colspan="3" class="text-center">No attendees</td></tr>`
      }
    </tbody>
  </table>

</div>
`).join('')}

<div style="margin-top: 6px; font-size: 10px;">
  ${meetings.length === 0 ? '<center><p><i>No Data Available</i></p></center>' : ''}
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };

  } catch (error) {
    showError(`Failed to print meetings report: ${error.message}`);
  }
};


const printBoq = async (id,project) => {

  try {
   const response = await axiosInstance.get(`boq?project_id=${id}`)
   const  row = response.data.data
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

const printContent = `
<!DOCTYPE html>
<html>
<head>
<style>
  body { font-family: 'Courier New', monospace; margin: 20px; font-size: 8px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; font-size: 9px; }
  .company-title h1 { font-size: 14px; margin: 5px 0; }
  .title { text-align: center; font-size: 12px; margin: 8px 0; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 8px; font-size: 9px; }
  th, td { border: 1px solid #000; padding: 3px 4px; }
  th { background-color: #f0f0f0; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .badge { padding: 2px 5px; border-radius: 2px; font-size: 8px; display: inline-block; }
  .badge-success { background-color: #28a745; color: white; }
  .badge-warning { background-color: #ffc107; color: black; }
  .badge-danger { background-color: #dc3545; color: white; }
  .badge-info { background-color: #17a2b8; color: white; }
  hr { border: 0; border-top: 1px solid #000; margin: 8px 0; }
  @media print { 
    body { margin: 5mm; } 
    table { page-break-inside: auto; }
    tr { page-break-inside: avoid; page-break-after: auto; }
  }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr>



<table class="items">
  <thead>
    <tr>
      <th>CODE/SN</th>
      <th>DESCRIPTION</th>
      <th>UNIT</th>
      <th>QUANTITY</th>
      <th>RATE</th>
      <th>RATE</th>
    </tr>
  </thead>
  <tbody>
    <tr class="boq-header">
      <td colspan="6" class="title">Bill of Quantity ${project}</td>
    </tr>
    ${(row).map((series, i) => `
      <tr style="border:0.2px solid black">
        <th colspan="1" class="text-center">SERIES ${i + 1}</th>
        <th colspan="5" style="text-align:start">${series.name}</th>
        ${(series.sections).map((section, j) => `
          <tr style="border:0.2px solid black">
            <th colspan="1" class="text-center">SECTION ${i + 1}.${j + 1}</th>
            <th colspan="5" style="text-align:start">${section.name}</th>
             ${(section.lines).map((line, l) => `
                  <tr>
                    <td class="text-center">${String.fromCharCode(97 + l)}</td>
                    <td class="text-start">${line.name}</td>
                    <td>${line.unit}</td>
                    <td>${line.quantity}</td>
                    <td class="text-end">${line.rate.toLocaleString()}</td>
                    <td class="text-end">${(line.rate * line.quantity).toLocaleString()}</td>
                  </tr>`
                ).join("")}

            ${(section.sub_sections).map((subsection, k) => `
              <tr style="border:0.2px solid black">
                <th colspan="1" class="text-center">${i + 1}.${j + 1}.${k + 1}</th>
                <th colspan="5" style="text-align:start">${subsection.name}</th>
                ${(subsection.lines).map((line, l) => `
                  <tr>
                    <td class="text-center">${String.fromCharCode(97 + l)}</td>
                    <td class="text-start">${line.name}</td>
                    <td>${line.unit}</td>
                    <td>${line.quantity}</td>
                    <td class="text-end">${line.rate.toLocaleString()}</td>
                    <td class="text-end">${(line.rate * line.quantity).toLocaleString()}</td>
                  </tr>`
                ).join("")}
              </tr>`
            ).join("")}
          </tr>`
        ).join("")}
      </tr>`
    ).join("")}
    ${(!row || row.length === 0) ? `<tr><td colspan="4">No items found</td></tr>` : ''}

    <tr class="summary-header">
      <th colspan="6" style="text-align:center">Summary</th>
    </tr>
${(() => {
  let grandTotal = 0;
  const rowsHtml = row.map((serie, x) => {
    const total = serie.sections.reduce((sAcc, section) => {
      const sectionLinesTotal = section.lines.reduce(
        (lAcc, line) => lAcc + line.quantity * line.rate,
        0
      );
      const subSectionsTotal = section.sub_sections.reduce((ssAcc, sub) => {
        return ssAcc + sub.lines.reduce((lAcc, line) => lAcc + line.quantity * line.rate, 0);
      }, 0);
      return sAcc + sectionLinesTotal + subSectionsTotal;
    }, 0);
    grandTotal += total;
    return `
      <tr>
        <th colspan="5" style="text-align:start">SERIES ${x + 1}</th>
        <th colspan="1" style="text-align:end">${total.toLocaleString()}</th>
      </tr>
    `;
  }).join("");
  return rowsHtml + `
    <tr>
      <th colspan="5" style="text-align:start">A Total of Bills</th>
      <th colspan="1" style="text-align:end">${grandTotal.toLocaleString()}</th>
    </tr>
  `;
})()}

  </tbody>
</table>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    console.error(`Failed to print report: ${error.message}`);
  }
};


const printIpc = async (projectId, project,ipc) => {
  try {
    const res = await axiosInstance.get(`boq?project_id=${projectId}&ipc_no=${ipc}`)
    const boq = res.data.data

    const iframe = document.createElement("iframe")
    iframe.style.display = "none"
    document.body.appendChild(iframe)

    const html = `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<style>
body{font-family:Courier New,monospace;font-size:8px;margin:10px}
h1{text-align:center;font-size:12px;margin:4px 0}
table{width:100%;border-collapse:collapse}
th,td{border:1px solid #000;padding:3px}
th{text-align:center;background:#f0f0f0}
.text-right{text-align:right}
.text-center{text-align:center}
.bg-ipc{background:beige}
@media print{
  thead{display:table-header-group;}
  tfoot{display:table-row-group;} 
  tr{page-break-inside:avoid;}
}
</style>
</head>
<body>

<h1>INTERIM PAYMENT CERTIFICATE – ${project}</h1>

<table>
<thead>
<tr>
  <th colspan="6">ORIGINAL BOQ</th>
  <th colspan="2">PREVIOUS IPC</th>
  <th colspan="2">THIS IPC</th>
  <th colspan="2">BALANCE</th>
</tr>
<tr>
  <th>SN</th>
  <th>DESCRIPTION</th>
  <th>UNIT</th>
  <th>QTY</th>
  <th>RATE</th>
  <th>TOTAL</th>
  <th>QTY</th>
  <th>TOTAL</th>
  <th class="bg-ipc">QTY</th>
  <th class="bg-ipc">TOTAL</th>
  <th>QTY</th>
  <th>TOTAL</th>
</tr>
</thead>
<tbody>

${boq.map((series,i)=>`
<tr>
  <th class="text-center">SERIES ${i+1}</th>
  <th colspan="11" style="text-align:left">${series.name}</th>
</tr>

${series.sections.map((sec,j)=>`
<tr>
  <th class="text-center">${i+1}.${j+1}</th>
  <th colspan="11" style="text-align:left">${sec.name}</th>
</tr>

${sec.lines.map((l,a)=>{
  const prev=l?.previous_progress?.quantity||0
  const curr=l?.progress?.quantity||0
  const bal=l.quantity-(prev+curr)
  return `
<tr>
<td class="text-center">${String.fromCharCode(97+a)}</td>
<td>${l.name}</td>
<td>${l.unit}</td>
<td>${l.quantity}</td>
<td class="text-right">${Number(l.rate).toLocaleString()}</td>
<td class="text-right">${(l.quantity*l.rate).toLocaleString()}</td>
<td class="text-center">${prev}</td>
<td class="text-right">${(prev*l.rate).toLocaleString()}</td>
<td class="text-center bg-ipc">${curr}</td>
<td class="text-right bg-ipc">${(curr*l.rate).toLocaleString()}</td>
<td class="text-center">${bal.toFixed(2)}  </td>
<td class="text-right">${(bal*l.rate).toLocaleString()} </td>
</tr>`
}).join("")}

${sec.sub_sections.map((sub,k)=>`
<tr>
  <th class="text-center">${i+1}.${j+1}.${k+1}</th>
  <th colspan="11" style="text-align:left">${sub.name}</th>
</tr>

${sub.lines.map((l,b)=>{
  const prev=l?.previous_progress?.quantity||0
  const curr=l?.progress?.quantity||0
  const bal=l.quantity-(prev+curr)
  return `
<tr>
<td class="text-center">${String.fromCharCode(97+b)}</td>
<td>${l.name}</td>
<td>${l.unit}</td>
<td>${l.quantity}</td>
<td class="text-right">${l.rate.toLocaleString()}</td>
<td class="text-right">${(l.quantity*l.rate).toLocaleString()}</td>
<td class="text-center">${prev}</td>
<td class="text-right">${(prev*l.rate).toLocaleString()}</td>
<td class="text-center bg-ipc">${curr}</td>
<td class="text-right bg-ipc">${(curr*l.rate).toLocaleString()}</td>
<td class="text-center">${bal}</td>
<td class="text-right">${(bal*l.rate).toLocaleString()}</td>
</tr>`
}).join("")}
`).join("")}
`).join("")}
`).join("")}

</tbody>

<tfoot>
<tr>
<th colspan="5" class="text-right">TOTAL</th>
<th class="text-right">
${boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+x.quantity*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+x.quantity*x.rate,0),0)
,0),0).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+(x?.previous_progress?.quantity||0)*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+(x?.previous_progress?.quantity||0)*x.rate,0),0)
,0),0).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+(x?.progress?.quantity||0)*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+(x?.progress?.quantity||0)*x.rate,0),0)
,0),0).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>{
const q=x.quantity||0
const p=x?.previous_progress?.quantity||0
const c=x?.progress?.quantity||0
return l+(q-(p+c))*x.rate
},0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>{
const q=x.quantity||0
const p=x?.previous_progress?.quantity||0
const c=x?.progress?.quantity||0
return l+(q-(p+c))*x.rate
},0),0)
,0),0).toLocaleString()}
</th>
</tr>

<tr>
<th colspan="5" class="text-right">ADD VAT 18%</th>
<th class="text-right">
${(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+x.quantity*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+x.quantity*x.rate,0),0)
,0),0) * 0.18).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+(x?.previous_progress?.quantity||0)*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+(x?.previous_progress?.quantity||0)*x.rate,0),0)
,0),0) * 0.18 ).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+(x?.progress?.quantity||0)*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+(x?.progress?.quantity||0)*x.rate,0),0)
,0),0) * 0.18 ).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>{
const q=x.quantity||0
const p=x?.previous_progress?.quantity||0
const c=x?.progress?.quantity||0
return l+(q-(p+c))*x.rate
},0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>{
const q=x.quantity||0
const p=x?.previous_progress?.quantity||0
const c=x?.progress?.quantity||0
return l+(q-(p+c))*x.rate
},0),0)
,0),0) * 0.18).toLocaleString()}
</th>
</tr>

<tr>
<th colspan="5" class="text-right">GRAND TOTAL</th>
<th class="text-right">
${(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+x.quantity*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+x.quantity*x.rate,0),0)
,0),0) + 


(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+x.quantity*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+x.quantity*x.rate,0),0)
,0),0) * 0.18)


).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+(x?.previous_progress?.quantity||0)*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+(x?.previous_progress?.quantity||0)*x.rate,0),0)
,0),0)

+

(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+(x?.previous_progress?.quantity||0)*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+(x?.previous_progress?.quantity||0)*x.rate,0),0)
,0),0) * 0.18 )


).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+(x?.progress?.quantity||0)*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+(x?.progress?.quantity||0)*x.rate,0),0)
,0),0)

+

(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>l+(x?.progress?.quantity||0)*x.rate,0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>l+(x?.progress?.quantity||0)*x.rate,0),0)
,0),0) * 0.18 )

).toLocaleString()}
</th>

<th></th>
<th class="text-right">
${(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>{
const q=x.quantity||0
const p=x?.previous_progress?.quantity||0
const c=x?.progress?.quantity||0
return l+(q-(p+c))*x.rate
},0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>{
const q=x.quantity||0
const p=x?.previous_progress?.quantity||0
const c=x?.progress?.quantity||0
return l+(q-(p+c))*x.rate
},0),0)
,0),0) 

+

(boq.reduce((t,s)=>t+s.sections.reduce((a,sec)=>a+
sec.lines.reduce((l,x)=>{
const q=x.quantity||0
const p=x?.previous_progress?.quantity||0
const c=x?.progress?.quantity||0
return l+(q-(p+c))*x.rate
},0)+
sec.sub_sections.reduce((ss,sub)=>ss+sub.lines.reduce((l,x)=>{
const q=x.quantity||0
const p=x?.previous_progress?.quantity||0
const c=x?.progress?.quantity||0
return l+(q-(p+c))*x.rate
},0),0)
,0),0) * 0.18)


).toLocaleString()}
</th>
</tr>


</tfoot>

</table>
</body>
</html>
`

    const doc = iframe.contentWindow.document
    doc.open()
    doc.write(html)
    doc.close()

    iframe.onload = () => {
      iframe.contentWindow.print()
      setTimeout(()=>document.body.removeChild(iframe),1000)
    }

  } catch (e) {
    console.error(e)
  }
}


//20 jan 2026
const printProjectPlanning = async (projectId) => {
  try {
    let selectedProject, budgets, unbudgeted;

    const projectResponse = await axiosInstance.get(`projects/${projectId}`);
    selectedProject = projectResponse.data;

    const budgetsResponse = await axiosInstance.get(`budgets?project_id=${projectId}`);
    budgets = budgetsResponse.data;

    try {
      const unbudgetedResponse = await axiosInstance.get(`unbudgeted-costs?project_id=${projectId}`);
      unbudgeted = unbudgetedResponse.data;
    } catch (error) {
      console.warn('Unbudgeted costs endpoint not available');
      unbudgeted = null;
    }

    const grandTotalBudgeted = budgets.reduce((sum, budget) => sum + (budget.total_cost || 0), 0);
    const grandTotalUsed = budgets.reduce((sum, budget) => sum + (budget.total_used_cost || 0), 0);
    const grandTotalBalance = grandTotalBudgeted - grandTotalUsed;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const currentDate = new Date().toLocaleDateString();

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Project Planning Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .budget-header { background-color: #e0e0e0; font-weight: bold; }
  .total-row { background-color: #d0d0d0; font-weight: bold; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  PROJECT PLANNING REPORT - ${selectedProject?.short_name || selectedProject?.name || 'N/A'}
</div>

<hr>

<table style="margin-top: 20px;">
  <thead>
    <tr class="budget-header">
      <th>No.</th>
      <th>Budget Name</th>
      <th class="text-right">Budgeted</th>
      <th class="text-right">Used</th>
      <th class="text-right">Balance</th>
    </tr>
  </thead>
  <tbody>
    ${budgets.map((budget, budgetIndex) => `
      <tr>
        <td>${budgetIndex + 1}</td>
        <td>${budget.name}</td>
        <td class="text-right">${formatNumber(budget.total_cost || 0)}</td>
        <td class="text-right">${formatNumber(budget.total_used_cost || 0)}</td>
        <td class="text-right">${formatNumber((budget.total_cost || 0) - (budget.total_used_cost || 0))}</td>
      </tr>
    `).join('')}
    <tr class="total-row">
      <td colspan="2" class="text-right"><strong>GRAND TOTAL:</strong></td>
      <td class="text-right"><strong>${formatNumber(grandTotalBudgeted)}</strong></td>
      <td class="text-right"><strong>${formatNumber(grandTotalUsed)}</strong></td>
      <td class="text-right"><strong>${formatNumber(grandTotalBalance)}</strong></td>
    </tr>
  </tbody>
</table>

${unbudgeted && unbudgeted.total_cost > 0 ? `
<table style="margin-top: 20px;">
  <thead>
    <tr class="budget-header">
      <th style="width: 50%;">UNBUDGETED COSTS</th>
      <th style="width: 50%;">Total: ${formatNumber(unbudgeted.total_cost)}</th>
    </tr>
  </thead>
</table>
` : ''}

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print planning report: ${error.message}`);
  }
};


const printBudgetReport = async (budgetId, projectId = null) => {
  let budget, items, project;
  
  if (budgetId) {
     try {
      // Fetch budget data with items and descriptions
      const budgetResponse = await axiosInstance.get(`budgets/${budgetId}`);
      budget = budgetResponse.data;
      items = budget.items || []; // Get items from budget response
      
      // Fetch project data if projectId is provided
      if (projectId) {
        const projectResponse = await axiosInstance.get(`projects/${projectId}`);
        project = projectResponse.data;
      }
    } catch (error) {
      showError('Failed to fetch budget data: ' + error.message);
      return;
    }
  } else {
    showError("Budget ID is required");
    return;
  }

  if (!budget) {
    showError("Budget data not available");
    return;
  }

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  const currentDate = new Date().toLocaleDateString();

  // Budget summary calculations
  const allocatedAmount = budget.funded_amount || 0;
  const totalBudgeted = budget.total_cost || 0;
  const totalUsed = budget.total_used_cost || 0;
  const totalBalance = totalBudgeted - totalUsed;
  const unallocatedAmount = allocatedAmount - totalBudgeted;

  const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Budget Report - ${budget.name}</title>
<style>
  body { font-family: Arial, sans-serif; margin: 40px; font-size: 14px; }
  .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px; }
  .logo { width: 160px; height: auto; }
  .report-box { border: 1px solid #000; padding: 5px 10px; font-weight: normal; font-size: 14px; text-align: center; margin-left: auto; border-radius: 5px; }
  .company-title { text-align: center; margin-top: 10px; flex-grow: 1; }
  .company-title h2 { margin: 5px 0; font-size: 18px; }
  .reg-info { position: absolute; top: 120px; right: 40px; text-align: right; font-size: 12px; line-height: 1.4; font-weight: normal; }
  .section-title { text-align: center; font-weight: bold; text-decoration: underline; margin: 15px 0 8px 0; font-size: 16px; margin-top: 1.5rem; margin-bottom: 1.5rem; }
  .budget-info table { width: 100%; border-collapse: collapse; margin-bottom: 12px; border: 1px solid #666; }
  .budget-info th, .budget-info td { padding: 6px; border: 1px solid #666; font-size: 13px; text-align: center; }
  .budget-info th { background-color: #f5f5f5; }
  .item-container { width: 100%; border: 1px solid #333; margin-bottom: 20px; padding: 10px; background-color: #fafafa; border-radius: 5px; }
  .description-table { width: 100%; border-collapse: collapse; margin: 4px 0 8px 0; font-size: 12px; border: 1px solid #666; }
  .description-table th, .description-table td { border: 1px solid #666; padding: 4px; }
  .description-table th { background-color: #f8f8f8; }
  .item-total-row { font-weight: bold; background-color: #d9d9d9; }
  .text-right { text-align: right; }
  .totals-table { width: 100%; border-collapse: collapse; margin-top: 20px; border: 1px solid #666; }
  .totals-table th, .totals-table td { border: 1px solid #666; padding: 8px; text-align: center; font-size: 14px; font-weight: bold; }
  .totals-table th { background-color: #f2f2f2; }
  @media print { body { margin: 8mm; } .no-print { display: none; } }
</style>
</head>
<body>

<div class="header">
  <img src="https://bushman.ink/copex.jpg" class="logo" />
  <div class="report-box">
     Report Date <br>
    <span style="color:red;">${currentDate}</span>
  </div>
</div>

<div class="reg-info">
  TIN: 103-826-519<br>
  VRN: 20-01-017530R
</div>

<div class="company-title">
  <h2>BUSHMAN SARARI TRACKERS CO.LTD</h2>
  <div>Msamvu, P.O.BOX 678, Morogoro</div>
  <div>Mobile, 0713 000 777, 0657 111 555</div>
</div>

<div class="section-title">BUDGET DETAILS</div>
<div><strong>BUDGET : ${budget.name} </strong></div> <br>
<div class="item-container">
<div class="budget-info">
  <table>
    <thead>
      <tr>
        <th>Project</th>
        <th>Allocated Amount</th>
        <th>Unallocated Amount</th>
        <th>Budget Cost</th>
        <th>Used Cost</th>
        <th>Balance</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>${project?.short_name || 'N/A'}</td>
        <td class="text-right">${formatNumber(allocatedAmount)} </td>
        <td class="text-right">${formatNumber(unallocatedAmount)} </td>
        <td class="text-right">${formatNumber(totalBudgeted)} </td>
        <td class="text-right">${formatNumber(totalUsed)} </td>
        <td class="text-right">${formatNumber(totalBalance)} </td>
      </tr>
    </tbody>
  </table>
</div>
</div>

<div class="section-title">BUDGET ITEMS DETAILS</div>

${items?.map((item, itemIndex) => {
  let itemTotalBudgeted = 0;
  let itemTotalUsed = 0;
  let itemTotalBalance = 0;
  
  const descriptionsHtml = item.descriptions?.map((desc, descIndex) => {
    const descBudgeted = (desc.cost || 0) * (desc.quantity || 0) * (desc.quantity_2 || 1);
    const descUsed = parseFloat(desc.used_cost) || 0;
    const descBalance = descBudgeted - descUsed;
    
    itemTotalBudgeted += descBudgeted;
    itemTotalUsed += descUsed;
    itemTotalBalance += descBalance;
    
    return `
      <tr>
        <td>${desc.name || '-'}</td>
        <td>${desc.units || '-'}</td>
        <td class="text-right">${desc.quantity || 0}</td>
        <td class="text-right">${desc.quantity_2 || 1}</td>
        <td class="text-right">${formatNumber(desc.cost || 0)}</td>
        <td class="text-right">${formatNumber(descBudgeted)}</td>
        <td class="text-right">${formatNumber(descUsed)}</td>
        <td class="text-right">${formatNumber(descBalance)}</td>
      </tr>
    `;
  }).join('') || '<tr><td colspan="8" class="text-center">No descriptions available</td></tr>';
  
  return `
    <div><strong>${item.name?.toUpperCase() || 'UNNAMED ITEM'}</strong></div><br>
    <div class="item-container">
      <table class="description-table">
        <thead>
          <tr>
            <th>Description</th>
            <th>Units</th>
            <th>Qty 1</th>
            <th>Qty 2</th>
            <th>Rate</th>
            <th>Budgeted</th>
            <th>Used</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          ${descriptionsHtml}
        </tbody>
        <tfoot>
          <tr class="item-total-row">
            <td colspan="5" style="text-align: left; padding-left: 10px;"><strong>Grand Total:</strong></td>
            <td class="text-right">${formatNumber(itemTotalBudgeted)}</td>
            <td class="text-right">${formatNumber(itemTotalUsed)}</td>
            <td class="text-right">${formatNumber(itemTotalBalance)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  `;
}).join('') || '<div>No items available</div>'}

<table class="totals-table">
  <thead>
    <tr>
      <th colspan="3">GRAND TOTAL SUMMARY</th>
    </tr>
    <tr>
      <th>Total Budgeted</th>
      <th>Total Used</th>
      <th>Total Balance</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="text-right">${formatNumber(totalBudgeted)} </td>
      <td class="text-right">${formatNumber(totalUsed)} </td>
      <td class="text-right">${formatNumber(totalBalance)} </td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 40px; text-align: center; font-size: 12px; border-top: 1px solid #666; padding-top: 8px;">
  <p>© ${new Date().getFullYear()} BUSHMAN SARARI TRACKERS CO.LTD | TIN: 103-826-519 | VRN: 20-01-017530R</p>
  <p>Msamvu, P.O.BOX 678, Morogoro | Mobile: 0713 000 777, 0657 111 555</p>
</div>

<div style="margin-top: 15px; font-size: 7px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

  const iframeDoc = iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(printContent);
  iframeDoc.close();

  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  };
};


//21 jan 2026
const printEmployeeLeave = async () => {
  try {
       
const calculateLeaveDays = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end - start);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  return diffDays;
};

    const response = await axiosInstance.get('employee-leave');
    const leaves = response.data.map((leave, index) => ({
      ...leave,
      employee: leave.employee?.name || 'N/A',
      start_date: leave.start_date ? formatDate(leave.start_date) : 'N/A',
      end_date: leave.end_date ? formatDate(leave.end_date) : 'N/A',
      leave_days: leave.leave_days || calculateLeaveDays(leave.start_date, leave.end_date),
      remark: leave.remark || '--'
    }));
    
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Employees Leave Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  EMPLOYEES LEAVE REPORT
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Employee</th>
      <th>Start Date</th>
      <th>End Date</th>
      <th class="text-center">Leave Days</th>
      <th class="text-center">Status</th>
      <th>Remark</th>
    </tr>
  </thead>
  <tbody>
    ${leaves.map((leave, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${leave.employee}</td>
      <td>${leave.start_date}</td>
      <td>${leave.end_date}</td>
      <td class="text-center">${leave.leave_days}</td>
      <td class="text-center">${leave.status?.name}</td>
      <td>${leave.remark}</td>
    </tr>
    `).join('')}
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print leave report: ${error.message}`);
  }
};

//22 jan 2026
const printLeaveRequests = async (leaves) => {

  try {
   const  items = leaves
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Employees Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; font-size: 12px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
EMPLOYEES LEAVE REQUESTS
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>SNo.</th>
      <th>Employee</th>
      <th>Leave Type</th>
      <th>Start Date</th>
      <th>End Date</th>
      <th>Days</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${items.map((data, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${data.employee || 'N/A'}</td>
      <td>${data.type || 'N/A'}</td>
      <td>${formatDate(data.start_date) || 'N/A'}</td>
      <td>${ formatDate(data.end_date) || 'N/A'}</td>
      <td class="text-right">${data.leave_days || 'N/A'}</td>
      <td>${data.status.name|| 'N/A'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="8" class="text-center"><strong>TOTAL LEAVE REQUESTS : ${items.length}</strong></td>
    </tr>
  </tbody>
</table>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    console.error(`Failed to print report: ${error.message}`);
  }
};


const printEmployeeList = async () => {
  try {
    // Fetch employees data
    const response = await axiosInstance.get('employees');
    const employees = response.data;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Employee List Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  EMPLOYEE LIST REPORT
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Name</th>
      <th>Department</th>
      <th>Salary</th>
      <th>Contract Date</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${employees.map((employee, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${employee.name || 'N/A'}</td>
      <td>${employee.department || '--'}</td>
      <td class="text-right">${employee.salary || '0'}</td>
      <td class="text-center">${employee.contract_date || 'N/A'}</td>
      <td class="text-center">${employee.status?.name || 'N/A'}</td>
    </tr>
    `).join('')}
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};

const printBudget = async (budgetId) => {
  if (!budgetId) {
    showError("Please provide a budget ID");
    return;
  }

  try {
    const budgetResponse = await axiosInstance.get(`budgets/${budgetId}`);
    const budget = budgetResponse.data;
    
    const projectResponse = await axiosInstance.get(`projects/${budget.project_id}`);
    const project = projectResponse.data;
    
    const items = budget.items || [];

    if (!Array.isArray(items)) {
      showError("Invalid budget items data");
      return;
    }

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    let materialTotal = 0;

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Budget Report - ${budget.name || 'N/A'}</title>
<style>
  body { font-family: Arial, sans-serif; margin: 20px; font-size: 14px; }
  .header { text-align: center; margin-bottom: 15px; }
  .company-name { font-size: 16px; font-weight: bold; margin-bottom: 5px; }
  .project-title { font-size: 14px; margin-bottom: 3px; }
  .contract-no { font-size: 13px; margin-bottom: 3px; }
  .budget-title { font-size: 14px; font-weight: bold; margin-bottom: 3px; }
  .volume-info { font-size: 13px; margin-bottom: 3px; }
  .date-info { font-size: 13px; margin-bottom: 10px; }
  .boq-info { font-size: 13px; margin-bottom: 10px; }
  .data-table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
  .data-table th, .data-table td { border: 1px solid #000; padding: 6px; text-align: left; font-size: 13px; }
  .data-table th { background-color: #f0f0f0; font-weight: bold; }
  .section-header { font-weight: bold; background-color: #e0e0e0; font-size: 14px; }
  .subtotal-row { font-weight: bold; background-color: #f5f5f5; font-size: 13px; }
  .subtotal-row td { text-align: center; }
  .subtotal-row td:last-child { text-align: right; }
  .total-row { font-weight: bold; background-color: #e0e0e0; font-size: 14px; }
  .total-row td { text-align: center; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  @media print { 
    body { margin: 10mm; } 
    .no-print { display: none; } 
  }
</style>
</head>
<body>

<table class="data-table">
  <tr>
    <td colspan="2" style="text-align: center; font-weight: bold; font-size: 16px;">COPEX CONTRACTORS COMPANY LIMITED</td>
  </tr>
  <tr>
    <td colspan="2" style="text-align: center; font-size: 14px; font-weight: bold;">${project?.project_name || 'PROJECT NAME'}</td>
  </tr>
  <tr>
    <td colspan="2" style="text-align: center; font-size: 13px; font-weight: bold;">CONTRACT NO. ${project?.contract_number || 'N/A'}</td>
  </tr>
  <tr>
    <td colspan="2" style="text-align: center; font-weight: bold; font-size: 14px;">ESTIMATED BUDGET FOR ${budget?.name || 'N/A'}</td>
  </tr>
  <tr>
    <td colspan="2" style="text-align: center; font-size: 13px; font-weight: bold;">${budget?.description || ''}</td>
  </tr>
  <tr>
    <td style="text-align: left; font-size: 13px; font-weight: bold;">REVIEWED ON : ${budget?.updated_at ? new Date(budget.updated_at).toLocaleDateString() : ''}</td>
    <td style="text-align: left; font-size: 13px; font-weight: bold;">START DATE : ${budget?.created_at ? new Date(budget.created_at).toLocaleDateString() : ''}</td>
  </tr>
  <tr>
    <td colspan="2" style="text-align: left; font-size: 13px; font-weight: bold;">BoQ Item No. ${budget?.boq_item_no || 'N/A'}</td>
  </tr>
</table>

${items.map((item, itemIdx) => {
  let itemTotal = 0;
  const descriptions = item?.descriptions || [];
  const itemDescriptionsHtml = descriptions.map((desc, descIdx) => {
    const amount = (desc?.quantity || 0) * (desc?.quantity_2 || 1) * (desc?.cost || 0);
    itemTotal += amount;
    return `
      <tr>
        <td class="text-center">${descIdx + 1}</td>
        <td>${desc?.name || 'N/A'}</td>
        <td class="text-center">${desc?.units || 'N/A'}</td>
        <td class="text-right">${desc?.quantity || 0}</td>
        <td class="text-right">${formatNumber(desc?.cost || 0)}</td>
        <td class="text-right">${formatNumber(amount)}</td>
      </tr>
    `;
  }).join('');
  
  materialTotal += itemTotal;
  
  return `
<!-- ${(item?.name || 'UNNAMED').toUpperCase()} SECTION -->
<table class="data-table">
  <tr class="section-header">
    <td colspan="7">${(item?.name || 'UNNAMED').toUpperCase()}</td>
  </tr>
  <tr>
    <th width="5%">#</th>
    <th width="55%">Description</th>
    <th width="10%">Unit</th>
    <th width="10%">Qty</th>
    <th width="10%">Rate</th>
    <th width="10%">Amount</th>
  </tr>
  ${itemDescriptionsHtml}
  <tr class="subtotal-row">
    <td colspan="5">SUBTOTAL</td>
    <td>${formatNumber(itemTotal)}</td>
  </tr>
</table>
  `;
}).join('')}

<!-- FINAL TOTALS -->
<table class="data-table">
  <tr class="total-row">
    <td colspan="5" class="text-center">TOTAL</td>
    <td class="text-right">${formatNumber(materialTotal)}</td>
  </tr>
  <tr class="total-row">
    <td colspan="5" class="text-center">ADD 5% CONTINGENCY</td>
    <td class="text-right">${formatNumber(materialTotal * 0.05)}</td>
  </tr>
  <tr class="total-row">
    <td colspan="5" class="text-center">ESTIMATED BUDGET FOR ${budget?.name || 'N/A'}</td>
    <td class="text-right">${formatNumber(materialTotal * 1.05)}</td>
  </tr>
</table>

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print budget report: ${error.message}`);
    console.error('Print budget error:', error);
  }
};

const printPendingGrnItemsReport = async () => {
  try {
    // Fetch pending GRN items
    const response = await axiosInstance.get('pending-grn-items');
    const grns = response.data.map((item, index) => ({
      ...item,
      SNo: index + 1,
      grn_no: item.grn_id, 
      lpo_no: item.approval_list_id, 
      project: item.requisition_items?.requisition_type?.requisition?.project?.short_name ?? 'no project',
      requester: item.requester,
      vendor: item.requisition_items?.vendor?.name ?? 'no vendor',                
      purpose: item.approval_list?.approval_group,
      item: item.requisition_items?.remark,
      units: item.requisition_items?.units,
      rate: formatNumber(item.requisition_items?.rate),                
      quantity: item.quantity,
      cost: formatNumber(item.quantity * item.requisition_items?.rate),
      description: item.requisition_items?.description,
    }));

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Pending Good Received Note Items Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 12px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 18px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 5px; font-size: 11px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  PENDING GOOD RECEIVED NOTE ITEMS REPORT
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>GRN</th>
      <th>LPO</th>
      <th>Project</th>
      <th>Requester</th>
      <th>Vendor</th>
      <th>Item</th>
      <th>Units</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Quantity</th>
      <th class="text-right">Cost</th>
      <th class="text-center">Action</th>
    </tr>
  </thead>
  <tbody>
    ${grns.map((grn, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${grn.grn_no || 'N/A'}</td>
      <td>${grn.lpo_no || 'N/A'}</td>
      <td>${grn.project || 'N/A'}</td>
      <td>${grn.requester || 'N/A'}</td>
      <td>${grn.vendor || 'N/A'}</td>
      <td>${grn.item || 'N/A'}</td>
      <td>${grn.units || 'N/A'}</td>
      <td class="text-right">${grn.rate || '0'}</td>
      <td class="text-right">${grn.quantity || '0'}</td>
      <td class="text-right">${grn.cost || '0'}</td>
      <td class="text-center"><input type="checkbox" /></td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="10" class="text-right"><strong>TOTAL COST:</strong></td>
      <td class="text-right"><strong>${formatNumber(grns.reduce((sum, grn) => {
        const cost = typeof grn.cost === 'string' ? parseFloat(grn.cost.replace(/,/g, '')) : grn.cost;
        return sum + (isNaN(cost) ? 0 : cost);
      }, 0))}</strong></td>
      <td></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};



const printBinCard = async (asset_id) => {


  try {
    const response = await axiosInstance.get(`asset-bincards?asset_id=${asset_id}`);
    const item = response.data;
    const card = {
      consuption_type: item.asset.consuption_type,
      asset: item.asset.name + "-" + item.asset.type_name,
      balance: item.balance,
      description: item.description,
      transactions: item.transactions
    };

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Asset Bin Card Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  .card-info { margin: 20px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; font-size: 12px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  ${card.asset} BIN CARD REPORT
</div>

<hr>

<div class="card-info" style="display:flex; justify-content:space-between;">
  <div>
    <p><strong>Asset:</strong> ${card.asset}</p>
    <p><strong>Consumption Type:</strong> ${card.consuption_type || '--'}</p>
  </div>
  <div>
    <p><strong>Current Balance:</strong> ${card.balance} Ltrs</p>
    <p><strong>Description:</strong> ${card.description || '--'}</p>
  </div>
</div>

<table>
<thead>
<tr>
  <th>No.</th>
  <th>Date</th>
  <th>Action</th>
  <th>Task</th>
  <th>Ratio</th>
  <th>Initial</th>
  <th>Final</th>
  <th>Difference</th>
  <th>Work Target</th>
  <th>Work Covered</th>
  <th>Unit</th>
  <th>Qty</th>
  <th>Balance</th>
  <th>Cost</th>
</tr>
</thead>
<tbody>
${card.transactions.map((tx, i) => `
<tr>
  <td>${i + 1}</td>
  <td>${tx.date || 'N/A'}</td>
  <td>${tx.action || '--'}</td>
  <td>${tx.task || '--'}</td>
  <td class="text-right">${tx.ratio || '--'}</td>
  <td class="text-right">${tx.initial_reading || '--'}</td>
  <td class="text-right">${tx.final_reading || '--'}</td>
  <td class="text-right">
  ${ (tx.final_reading - tx.initial_reading) >= 0 
      ? (tx.final_reading - tx.initial_reading).toFixed(2) 
      : '---' }
</td>
  <td class="text-right">${tx.work_target || '--'}</td>
  <td class="text-right">${tx.work_covered || '--'}</td>
  <td class="text-right">${tx.unit || '--'}</td>
  <td class="text-right">${tx.quantity || 0}</td>
  <td class="text-right">${tx.balance || 0}</td>
   <td class="text-right">${formatNumber(tx.quantity * tx.rate || 0)}</td>
</tr>
`).join('')}
<tr>
  <td colspan="12" class="text-right"><strong>FINAL BALANCE:</strong></td>
  <td class="text-right"><strong>${card.balance} Ltrs</strong></td>
</tr>
</tbody>
</table>

</body>
</html>
`;

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(printContent);
    doc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => document.body.removeChild(iframe), 1000);
    };

  } catch (error) {
    showError("Failed to print bin card: " + error.message);
  }
};

//20 feb 2026
const printProjects = async () => {
  try {
    const response = await axiosInstance.get('/projects'); 
    const projects = response.data || [];

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const tableRows = projects.map((project, index) => `
      <tr>
        <td>${index + 1}</td>
        <td>${project.project_name || 'N/A'}</td>
        <td>${project.short_name || 'N/A'}</td>
        <td>${project.contract_number || 'N/A'}</td>
        <td>${project.financial_year || 'N/A'}</td>
        <td>${project.client || 'N/A'}</td>
        <td class="text-right">${Number(project.project_cost || 0).toLocaleString()}</td>
        <td>${project.start_date || 'N/A'}</td>
        <td>${project.end_date || 'N/A'}</td>
        <td>${project.status || 'N/A'}</td>
      </tr>
    `).join('');

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Projects Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; font-size: 11px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  PROJECTS LIST
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Project Name</th>
      <th>Short Name</th>
      <th>Contract No.</th>
      <th>Financial Year</th>
      <th>Client</th>
      <th class="text-right">Project Cost</th>
      <th>Start Date</th>
      <th>End Date</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${tableRows}
  </tbody>
</table>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };

  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};

//03/03/2026
const printSparesStatement = async (assetId) => {
  try {
    // Fetch spares statement data from API
    const response = await axiosInstance.get(`asset-spares-statement?asset_id=${assetId}`);
    const data = response.data;
    const sparesStatement = data.spares || [];
    const assetName = sparesStatement.length > 0 ? sparesStatement[0].asset_name : 'N/A';
    const assetType = sparesStatement.length > 0 ? sparesStatement[0].asset_type : 'N/A';
    const asset = assetName + ' - ' + assetType;
    // Calculate total cost
    const totalSparesCost = response.data.total_cost || 0
     

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Spares Statement Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  SPARES STATEMENT FOR ${asset}
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Card</th>
      <th>Date</th>
      <th>Spare</th>
      <th>Unit</th>
      <th class="text-right">Quantity</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${sparesStatement.map((spare, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${spare.jobcard || 'N/A'}</td>
      <td>${formatDate(spare.created_at) || 'N/A'}</td>
      <td>${spare.spare || 'N/A'}</td>
      <td>${spare.unit || 'N/A'}</td>
      <td class="text-right">${spare.quantity || '0'}</td>
      <td class="text-right">${formatNumber(spare.rate || 0)}</td>
      <td class="text-right">${formatNumber(spare.cost || 0)}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="7" class="text-right"><strong>TOTAL COST:</strong></td>
      <td class="text-right"><strong>${formatNumber(totalSparesCost)}</strong></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};

const printTyresStatement = async (assetId) => {
  try {
    // Fetch tyres statement data from API
    const response = await axiosInstance.get(`asset-tyres-statement?asset_id=${assetId}`);
    const data = response.data;
    const tyresStatement = data.tyres || [];
  const assetName = tyresStatement.length > 0 ? tyresStatement[0].asset_name : 'N/A';
    const assetType = tyresStatement.length > 0 ? tyresStatement[0].asset_type : 'N/A';
    const asset = assetName + ' - ' + assetType;
    // Calculate total cost
    const totalTyresCost = response.data.total_cost || 0;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Tyres Statement Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  TYRES STATEMENT FOR ${asset}
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Card</th>
      <th>Date</th>
      <th>Tyre</th>
      <th>Tyre No.</th>
      <th class="text-right">Quantity</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${tyresStatement.map((tyre, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${tyre.jobcard_id || 'N/A'}</td>
      <td>${formatDate(tyre.created_at) || 'N/A'}</td>
      <td>${tyre.tyre || 'N/A'}</td>
      <td>${tyre.tyre_no || 'N/A'}</td>
      <td class="text-right">${tyre.quantity || '0'}</td>
      <td class="text-right">${formatNumber(tyre.rate || 0)}</td>
      <td class="text-right">${formatNumber(tyre.cost || 0)}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="7" class="text-right"><strong>TOTAL COST:</strong></td>
      <td class="text-right"><strong>${formatNumber(totalTyresCost)}</strong></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};

// 04 march 2026
const printDefectsReport = async (assetId) => {
  try {
    // Fetch defects statement from API
    const response = await axiosInstance.get(`asset-defects-statement?asset_id=${assetId}`);
    const defectsData = response.data.defects.map((item, index) => ({
      ...item,
      Sno: index + 1,
      jobcard: item.job_card_id,
      date: item.date,
      defect: item.description,
      reported_by: item.reported_by,
      machine_name: item.job_card.machine.name,
      machine_type: item.job_card.machine.type_name,
    }));
    const assetName = defectsData.length > 0 ? defectsData[0].machine_name : 'N/A';
    const assetType = defectsData.length > 0 ? defectsData[0].machine_type : 'N/A';
    const asset = assetName + ' - ' + assetType;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Defects Reported Statement</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  DEFECTS REPORTED FOR ${asset}
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Job Card</th>
      <th>Date</th>
      <th>Defect Description</th>
      <th>Reported By</th>
    </tr>
  </thead>
  <tbody>
    ${defectsData.map((defect, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${defect.jobcard || 'N/A'}</td>
      <td>${defect.date || 'N/A'}</td>
      <td>${defect.defect || 'N/A'}</td>
      <td>${defect.reported_by || 'N/A'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="5" class="text-center"><strong>TOTAL DEFECTS: ${defectsData.length}</strong></td>
    </tr>
  </tbody>
</table>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    console.log(error);
    showError(`Failed to print defects report: ${error.message}`);
  }
};

const printActionsTaken = async (assetId) => {
  try {
    // Fetch the latest work done statement data
    const response = await axiosInstance.get(`asset-work-done-statement?asset_id=${assetId}`);
    const workDoneData = response.data.work_logs.map((item, index) => ({
      ...item,
      Sno: index + 1,
      jobcard: item.job_card_id,
      date: item.date,
      description: item.description,
      reported_by: item.reported_by,
      machine_name: item.job_card.machine.name,
      machine_type: item.job_card.machine.type_name,
    }));
    const assetName = workDoneData.length > 0 ? workDoneData[0].machine_name : 'N/A';
    const assetType = workDoneData.length > 0 ? workDoneData[0].machine_type : 'N/A';
    const asset = assetName + ' - ' + assetType;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Actions Taken Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  ACTIONS TAKEN REPORT FOR ${asset}
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Job Card</th>
      <th>Date</th>
      <th>Description</th>
      <th>Reported By</th>
    </tr>
  </thead>
  <tbody>
    ${workDoneData.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.jobcard || 'N/A'}</td>
      <td>${item.date || 'N/A'}</td>
      <td>${item.description || 'N/A'}</td>
      <td>${item.reported_by || 'N/A'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="5" class="text-center"><strong>TOTAL ACTIONS TAKEN: ${workDoneData.length}</strong></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};

const printMaintenanceStatement = async (assetId) => {
  try {
    // Fetch maintenance statement data
    const response = await axiosInstance.get(`asset-maintenance-statement?asset_id=${assetId}`);
    const maintenanceData = response.data.data || [];
    const totalCost = response.data.total_cost || 0;
    const assetInfo = response.data.asset || {};

    const assetName = maintenanceData.length > 0 ? maintenanceData[0].asset_name : 'N/A';
    const assetType = maintenanceData.length > 0 ? maintenanceData[0].asset_type : 'N/A';
    const asset = assetName + ' - ' + assetType;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Asset Maintenance Statement</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  .asset-info { margin: 20px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style" style="font-size: 16px;">
  ASSET MAINTENANCE STATEMENT FOR ${asset}
</div>

<hr>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Job Card</th>
      <th>Date</th>
      <th>Description</th>
      <th>Beneficiary</th>
      <th class="text-right">Quantity</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${maintenanceData.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.jobcard_id || 'N/A'}</td>
      <td>${formatDate(item.created_at) || 'N/A'}</td>
      <td>${item.description || 'N/A'}</td>
      <td>${item.beneficiary || 'N/A'}</td>
      <td class="text-right">${item.quantity || '0'}</td>
      <td class="text-right">${formatNumber(item.rate) || '0'}</td>
      <td class="text-right">${formatNumber(item.quantity * item.rate) || '0'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="7" class="text-right"><strong>TOTAL COST:</strong></td>
      <td class="text-right"><strong>${formatNumber(totalCost)}</strong></td>
    </tr>
  </tbody>
</table>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print maintenance statement: ${error.message}`);
  }
};

const printFuelStatement = async (assetId) => {
  try {
    // Fetch fuel statement data
    const response = await axiosInstance.get(`asset-fuel-statement?asset_id=${assetId}`);
    const siteFuel = response.data.site_fuel || [];
    const headOfficeFuel = response.data.head_office_fuel || [];
    const asset = response.data.asset.name + ' - ' + response.data.asset.type_name;
    const fuelType = response.data.asset.fuel_type;

    let siteFuelTotal = 0;
    let headOfficeFuelTotal = 0;

    const siteFuelData = siteFuel.map((item, index) => {
      const appliedRate = item.rate && parseFloat(item.rate) > 0 ? parseFloat(item.rate) : 2720;
      const quantity = parseFloat(item.quantity) || 0;
      const cost = quantity * appliedRate;
      siteFuelTotal += cost;

      return {
        Sno: index + 1,
        date: formatDate(item.date),
        task: item.task ?? '---',
        quantity: quantity,
        rate: formatNumber(appliedRate),
        cost: formatNumber(cost)
      };
    });

    const headOfficeFuelData = headOfficeFuel.map((item, index) => {
      const appliedRate = item.rate && parseFloat(item.rate) > 0 ? parseFloat(item.rate) : 2720;
      const quantity = parseFloat(item.quantity) || 0;
      const cost = quantity * appliedRate;
      headOfficeFuelTotal += cost;

      return {
        Sno: index + 1,
        date: formatDate(item.created_at),
        task: item.task ?? '---',
        quantity: quantity,
        rate: formatNumber(appliedRate),
        cost: formatNumber(cost)
      };
    });

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Fuel Statement Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .text-style { font-family: 'Courier New', monospace; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  .section-title { font-size: 16px; margin: 20px 0 10px 0; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; margin-bottom: 20px; }
  th, td { border: 0.5px solid #000; padding: 6px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 0px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title text-style">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr style="margin-top:20px">

<div class="title text-style">
  ${fuelType.toUpperCase()} STATEMENT FOR ${asset}
</div>

<hr>

<div class="section-title">SITE ${fuelType.toUpperCase()} STATEMENT</div>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Date</th>
      <th>Task</th>
      <th class="text-right">Quantity (L)</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${siteFuelData.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.date || 'N/A'}</td>
      <td>${item.task || 'N/A'}</td>
      <td class="text-right">${item.quantity || '0'}</td>
      <td class="text-right">${item.rate || '0'}</td>
      <td class="text-right">${item.cost || '0'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="5" class="text-right"><strong>SITE ${fuelType.toUpperCase()} TOTAL:</strong></td>
      <td class="text-right"><strong>${formatNumber(siteFuelTotal)}</strong></td>
    </tr>
  </tbody>
</table>

<div class="section-title">HEAD OFFICE ${fuelType.toUpperCase()} STATEMENT</div>

<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Date</th>
      <th>Task</th>
      <th class="text-right">Quantity (L)</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${headOfficeFuelData.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.date || 'N/A'}</td>
      <td>${item.task || 'N/A'}</td>
      <td class="text-right">${item.quantity || '0'}</td>
      <td class="text-right">${item.rate || '0'}</td>
      <td class="text-right">${item.cost || '0'}</td>
    </tr>
    `).join('')}
    <tr>
      <td colspan="5" class="text-right"><strong>HEAD OFFICE ${fuelType.toUpperCase()} TOTAL:</strong></td>
      <td class="text-right"><strong>${formatNumber(headOfficeFuelTotal)}</strong></td>
    </tr>
  </tbody>
</table>

<table style="margin-top: 20px;">
  <tbody>
    <tr>
      <td colspan="5" class="text-right"><strong>GRAND TOTAL:</strong></td>
      <td class="text-right"><strong>${formatNumber(siteFuelTotal + headOfficeFuelTotal)}</strong></td>
    </tr>
  </tbody>
</table>

<div style="margin-top: 15px; font-size: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print report: ${error.message}`);
  }
};

const printJobCards = async (assetId) => {
  try {

    const jobCardResponse = await axiosInstance.get(
      `job-card?asset_id=${assetId}`
    );

    const summaryResponse = await axiosInstance.get(
      `jobcard-summary-count?asset_id=${assetId}`
    );

    const summary = summaryResponse.data || {};

    const jobCardsData = (jobCardResponse.data || []).map((item, index) => ({
      ...item,
      Sno: index + 1,
      date: item.date_created || 'N/A',
      card: item.id || 'N/A',
      current_km_svc: item.current_km_of_service ?? '---',
      next_km_svc: item.next_km_of_service ?? '---',
      name:
        (item.machine?.name || '') +
        ' - ' +
        (item.machine?.type_name || ''),
      status: {
        key: item.status?.name || 'N/A',
        class: item.status?.color || ''
      }
    }));

    if (!jobCardsData.length) {
      showError("No job cards found for this asset.");
      return;
    }

    const asset =
      jobCardsData[0]?.machine?.name +
      ' - ' +
      jobCardsData[0]?.machine?.type_name;

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Job Cards Report</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 13px; }
  .company-title { text-align: center; }
  .title { text-align: center; font-size: 20px; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  th, td { border: 0.5px solid #000; padding: 6px; font-size: 12px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-center { text-align: center; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 10px 0; }
  .summary { font-size: 13px; margin-top: 5px; }
  .abbr { font-size: 11px; margin-top: 5px; }
  
  /* Card Grid Layout */
  .summary-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin: 20px 0;
  }
  .summary-card {
    border: 1px solid #000;
    padding: 10px;
    text-align: center;
    background-color: #f9f9f9;
  }
  .summary-card h6 {
    margin: 0 0 5px 0;
    font-size: 12px;
    font-weight: bold;
  }
  .summary-card p {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    color: #4361ee;
  }
  
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title">
  <i>
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
  </i>
</div>

<hr>

<div class="title">
  JOB CARDS FOR ${asset}
</div>

<hr>

<div class="summary">
  <strong>Job Card Issues</strong>
</div>

<div class="summary-grid">
  <div class="summary-card">
    <h6>BODY WORKS</h6>
    <p>${summary.bodyworks || 0}</p>
  </div>
  
  <div class="summary-card">
    <h6>ELECTRICAL WORK</h6>
    <p>${summary.electric || 0}</p>
  </div>
  
  <div class="summary-card">
    <h6>SPARES</h6>
    <p>${summary.spares || 0}</p>
  </div>
  
  <div class="summary-card">
    <h6>TYRES</h6>
    <p>${summary.tyres || 0}</p>
  </div>
  
  <div class="summary-card">
    <h6>LABOUR</h6>
    <p>${summary.labour || 0}</p>
  </div>
  
  <div class="summary-card">
    <h6>ADDITIONAL</h6>
    <p>${summary.additional || 0}</p>
  </div>
  
  <div class="summary-card">
    <h6>DEFECTS</h6>
    <p>${summary.defects || 0}</p>
  </div>
  
  <div class="summary-card">
    <h6>WORK DONE</h6>
    <p>${summary.work_done || 0}</p>
  </div>
</div>

<div class="abbr">
  <strong>Abbreviations:</strong>
  BW: Body Works,
  EW: Electrical Works,
  TY: Tyres,
  LC: Labour Cost,
  SP: Spares,
  FW: Fabrication Work,
  OW: Other Works
</div>
<div class="summary">
  <strong>Job Cards List</strong>
</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Job Card</th>
      <th>Date</th>
      <th>Service Type</th>
      <th>Current Service</th>
      <th>Next Service</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${jobCardsData.map((jobcard, index) => `
      <tr>
        <td>${index + 1}</td>
        <td>${jobcard.card}</td>
        <td>${jobcard.date}</td>
        <td>
          ${jobcard.service_type || '---'}
          ${jobcard.available_costnotes ? ' (' + jobcard.available_costnotes + ')' : ''}
        </td>
        <td>${jobcard.current_km_svc}</td>
        <td>${jobcard.next_km_svc}</td>
        <td>${jobcard.status?.key}</td>
      </tr>
    `).join('')}
    <tr>
      <td colspan="7" class="text-center">
        <strong>TOTAL JOB CARDS: ${jobCardsData.length}</strong>
      </td>
    </tr>
  </tbody>
</table>

</body>
</html>
`;

    // ==========================
    // 6️⃣ Write to Iframe
    // ==========================
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    // ==========================
    // 7️⃣ Trigger Print
    // ==========================
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };

  } catch (error) {
    console.error(error);
    showError(`Failed to print job cards: ${error.message}`);
  }
};

//05 march 2026
const printAssetSummary = async (assetId) => {
  try {
    // Fetch all asset-related data in parallel
    const [
      sparesResponse,
      tyresResponse,
      defectsResponse,
      actionsResponse,
      maintenanceResponse,
      fuelResponse,
      jobCardsResponse,
      binCardResponse
    ] = await Promise.all([
      axiosInstance.get(`asset-spares-statement?asset_id=${assetId}`),
      axiosInstance.get(`asset-tyres-statement?asset_id=${assetId}`),
      axiosInstance.get(`asset-defects-statement?asset_id=${assetId}`),
      axiosInstance.get(`asset-work-done-statement?asset_id=${assetId}`),
      axiosInstance.get(`asset-maintenance-statement?asset_id=${assetId}`),
      axiosInstance.get(`asset-fuel-statement?asset_id=${assetId}`),
      axiosInstance.get(`job-card?asset_id=${assetId}`),
      axiosInstance.get(`asset-bincards?asset_id=${assetId}`)
    ]);

    // Extract data
    const spares = sparesResponse.data.spares || [];
    const sparesTotalCost = sparesResponse.data.total_cost || 0;
    
    const tyres = tyresResponse.data.tyres || [];
    const tyresTotalCost = tyresResponse.data.total_cost || 0;
    
    const defects = defectsResponse.data.defects || [];
    
    const actions = actionsResponse.data.work_logs || [];
    
    const maintenance = maintenanceResponse.data.data || [];
    const maintenanceTotalCost = maintenanceResponse.data.total_cost || 0;
    
    const siteFuel = fuelResponse.data.site_fuel || [];
    const headOfficeFuel = fuelResponse.data.head_office_fuel || [];
    const fuelType = fuelResponse.data.asset.fuel_type;
    
    const jobCards = jobCardsResponse.data || [];
    
    const binCard = binCardResponse.data;

    // Get asset info
    const assetName = spares[0]?.asset_name || tyres[0]?.asset_name || binCard?.asset?.name || 'N/A';
    const assetType = spares[0]?.asset_type || tyres[0]?.asset_type || binCard?.asset?.type_name || 'N/A';
    const asset = `${assetName} - ${assetType}`;

    // Calculate fuel totals
    let siteFuelTotal = 0;
    let headOfficeFuelTotal = 0;

    siteFuel.forEach(item => {
      const rate = item.rate && parseFloat(item.rate) > 0 ? parseFloat(item.rate) : 2720;
      const quantity = parseFloat(item.quantity) || 0;
      siteFuelTotal += quantity * rate;
    });

    headOfficeFuel.forEach(item => {
      const rate = item.rate && parseFloat(item.rate) > 0 ? parseFloat(item.rate) : 2720;
      const quantity = parseFloat(item.quantity) || 0;
      headOfficeFuelTotal += quantity * rate;
    });

    const totalFuelCost = siteFuelTotal + headOfficeFuelTotal;
    const grandTotalCost = sparesTotalCost + tyresTotalCost + maintenanceTotalCost + totalFuelCost;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const printContent = `
<!DOCTYPE html>
<html>
<head>
<title>Asset Summary Report - ${asset}</title>
<style>
  body { font-family: 'Courier New', monospace; margin: 40px; font-size: 12px; }
  .company-title { text-align: center; }
  .company-title h1 { font-size: 18px; margin: 5px 0; }
  .title { text-align: center; font-size: 16px; margin: 10px 0; font-weight: bold; }
  .section-title { font-size: 14px; margin: 20px 0 10px 0; font-weight: bold; background-color: #e0e0e0; padding: 5px; }
  table { width: 100%; border-collapse: collapse; margin-top: 10px; margin-bottom: 20px; }
  th, td { border: 0.5px solid #000; padding: 5px; font-size: 11px; }
  th { background-color: #f8f8f8; font-weight: bold; }
  .text-right { text-align: right; }
  .text-center { text-align: center; }
  .summary-box { padding: 10px; margin: 20px 0; background-color: #f9f9f9; }
  hr { border: 0; border-top: 0.5px solid #000; margin: 10px 0; }
  @media print { body { margin: 10mm; } }
</style>
</head>
<body>

<div class="company-title">
  <h1>BUSHMAN SARARI TRACKERS CO.LTD</h1>
  <div><b>Address:</b> Msamvu, P.O.BOX 678, Morogoro</div>
  <div><b>Tel:</b> 0713 000 777, 0657 111 555</div>
  <div><b>Email:</b> info@copexcontractors.co.tz</div>
  <div><b>TIN:</b> 103-826-519 &nbsp;&nbsp; <b>VRN:</b> 20-01-017530R</div>
</div>

<hr>

<div class="title">COMPREHENSIVE ASSET SUMMARY REPORT<br>${asset}</div>

<hr>

<!-- SUMMARY BOX -->
<div class="summary-box">
  <h3 style="margin-top: 0;">COST SUMMARY</h3>
  <table style="margin: 0;">
    <tr>
      <td><strong>Spares Cost:</strong></td>
      <td class="text-right">${formatNumber(sparesTotalCost)}</td>
    </tr>
    <tr>
      <td><strong>Tyres Cost:</strong></td>
      <td class="text-right">${formatNumber(tyresTotalCost)}</td>
    </tr>
    <tr>
      <td><strong>Maintenance Cost:</strong></td>
      <td class="text-right">${formatNumber(maintenanceTotalCost)}</td>
    </tr>
    <tr>
      <td><strong>${fuelType.toUpperCase()} Cost:</strong></td>
      <td class="text-right">${formatNumber(totalFuelCost)}</td>
    </tr>
    <tr style="background-color: #d0d0d0; font-weight: bold;">
      <td><strong>GRAND TOTAL COST:</strong></td>
      <td class="text-right">${formatNumber(grandTotalCost)}</td>
    </tr>
  </table>

</div>

${spares.length > 0 ? `
<!-- SPARES STATEMENT -->
<div class="section-title">SPARES STATEMENT</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Card</th>
      <th>Date</th>
      <th>Spare</th>
      <th>Unit</th>
      <th class="text-right">Qty</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${spares.slice(0, 10).map((spare, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${spare.jobcard_id || 'N/A'}</td>
      <td>${formatDate(spare.created_at)}</td>
      <td>${spare.spare || 'N/A'}</td>
      <td>${spare.unit || 'N/A'}</td>
      <td class="text-right">${spare.quantity || 0}</td>
      <td class="text-right">${formatNumber(spare.rate || 0)}</td>
      <td class="text-right">${formatNumber(spare.cost || 0)}</td>
    </tr>
    `).join('')}
    ${spares.length > 10 ? `<tr><td colspan="8" class="text-center"><i>... and ${spares.length - 10} more items</i></td></tr>` : ''}
    <tr style="font-weight: bold;">
      <td colspan="7" class="text-right">TOTAL:</td>
      <td class="text-right">${formatNumber(sparesTotalCost)}</td>
    </tr>
  </tbody>
</table>
` : ''}

${tyres.length > 0 ? `
<!-- TYRES STATEMENT -->
<div class="section-title">TYRES STATEMENT</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Card</th>
      <th>Date</th>
      <th>Tyre</th>
      <th>Tyre No.</th>
      <th class="text-right">Qty</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${tyres.slice(0, 10).map((tyre, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${tyre.jobcard_id || 'N/A'}</td>
      <td>${formatDate(tyre.created_at)}</td>
      <td>${tyre.tyre || 'N/A'}</td>
      <td>${tyre.tyre_no || 'N/A'}</td>
      <td class="text-right">${tyre.quantity || 0}</td>
      <td class="text-right">${formatNumber(tyre.rate || 0)}</td>
      <td class="text-right">${formatNumber(tyre.cost || 0)}</td>
    </tr>
    `).join('')}
    ${tyres.length > 10 ? `<tr><td colspan="8" class="text-center"><i>... and ${tyres.length - 10} more items</i></td></tr>` : ''}
    <tr style="font-weight: bold;">
      <td colspan="7" class="text-right">TOTAL:</td>
      <td class="text-right">${formatNumber(tyresTotalCost)}</td>
    </tr>
  </tbody>
</table>
` : ''}

${maintenance.length > 0 ? `
<!-- MAINTENANCE STATEMENT -->
<div class="section-title">MAINTENANCE STATEMENT</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Card</th>
      <th>Date</th>
      <th>Description</th>
      <th>Beneficiary</th>
      <th class="text-right">Qty</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${maintenance.slice(0, 10).map((item, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${item.jobcard_id || 'N/A'}</td>
      <td>${formatDate(item.created_at)}</td>
      <td>${item.description || 'N/A'}</td>
      <td>${item.beneficiary || 'N/A'}</td>
      <td class="text-right">${item.quantity || 0}</td>
      <td class="text-right">${formatNumber(item.rate || 0)}</td>
      <td class="text-right">${formatNumber((item.quantity || 0) * (item.rate || 0))}</td>
    </tr>
    `).join('')}
    ${maintenance.length > 10 ? `<tr><td colspan="8" class="text-center"><i>... and ${maintenance.length - 10} more items</i></td></tr>` : ''}
    <tr style="font-weight: bold;">
      <td colspan="7" class="text-right">TOTAL:</td>
      <td class="text-right">${formatNumber(maintenanceTotalCost)}</td>
    </tr>
  </tbody>
</table>
` : ''}

${(siteFuel.length > 0 || headOfficeFuel.length > 0) ? `
<!-- ${fuelType.toUpperCase()} STATEMENT -->
<div class="section-title">${fuelType.toUpperCase()} STATEMENT</div>

${siteFuel.length > 0 ? `
<!-- SITE ${fuelType.toUpperCase()} TABLE -->
<p><strong>Site ${fuelType.toUpperCase()}</strong></p>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Date</th>
      <th>Task</th>
      <th class="text-right">Quantity (L)</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${siteFuel.slice(0, 10).map((item, i) => {
      const rate = item.rate && parseFloat(item.rate) > 0 ? parseFloat(item.rate) : 2720;
      const quantity = parseFloat(item.quantity) || 0;
      const cost = quantity * rate;
      return `
      <tr>
        <td>${i + 1}</td>
        <td>${formatDate(item.date)}</td>
        <td>${item.task || '---'}</td>
        <td class="text-right">${quantity}</td>
        <td class="text-right">${formatNumber(rate)}</td>
        <td class="text-right">${formatNumber(cost)}</td>
      </tr>
      `;
    }).join('')}
    ${siteFuel.length > 10 ? `<tr><td colspan="6" class="text-center"><i>... and ${siteFuel.length - 10} more records</i></td></tr>` : ''}
    <tr style="font-weight: bold;">
      <td colspan="5" class="text-right">SITE ${fuelType.toUpperCase()} TOTAL:</td>
      <td class="text-right">${formatNumber(siteFuelTotal)}</td>
    </tr>
  </tbody>
</table>
` : ''}

${headOfficeFuel.length > 0 ? `
<!-- HEAD OFFICE ${fuelType.toUpperCase()} TABLE -->
<p><strong>Head Office ${fuelType.toUpperCase()}</strong></p>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Date</th>
      <th>Task</th>
      <th class="text-right">Quantity (L)</th>
      <th class="text-right">Rate</th>
      <th class="text-right">Cost</th>
    </tr>
  </thead>
  <tbody>
    ${headOfficeFuel.slice(0, 10).map((item, i) => {
      const rate = item.rate && parseFloat(item.rate) > 0 ? parseFloat(item.rate) : 2720;
      const quantity = parseFloat(item.quantity) || 0;
      const cost = quantity * rate;
      return `
      <tr>
        <td>${i + 1}</td>
        <td>${formatDate(item.created_at)}</td>
        <td>${item.task || '---'}</td>
        <td class="text-right">${quantity}</td>
        <td class="text-right">${formatNumber(rate)}</td>
        <td class="text-right">${formatNumber(cost)}</td>
      </tr>
      `;
    }).join('')}
    ${headOfficeFuel.length > 10 ? `<tr><td colspan="6" class="text-center"><i>... and ${headOfficeFuel.length - 10} more records</i></td></tr>` : ''}
    <tr style="font-weight: bold;">
      <td colspan="5" class="text-right">HEAD OFFICE ${fuelType.toUpperCase()} TOTAL:</td>
      <td class="text-right">${formatNumber(headOfficeFuelTotal)}</td>
    </tr>
  </tbody>
</table>
` : ''}

<!-- ${fuelType.toUpperCase()} GRAND TOTAL -->
<table style="margin-top: 10px;">
  <tbody>
    <tr style="font-weight: bold; background-color: #d0d0d0;">
      <td colspan="5" class="text-right">${fuelType.toUpperCase()} GRAND TOTAL:</td>
      <td class="text-right">${formatNumber(totalFuelCost)}</td>
    </tr>
  </tbody>
</table>
` : ''}

${defects.length > 0 ? `
<!-- DEFECTS -->
<div class="section-title">DEFECTS REPORTED</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Card</th>
      <th>Date</th>
      <th>Defect Description</th>
      <th>Reported By</th>
    </tr>
  </thead>
  <tbody>
    ${defects.slice(0, 10).map((defect, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${defect.job_card_id || 'N/A'}</td>
      <td>${defect.date || 'N/A'}</td>
      <td>${defect.description || 'N/A'}</td>
      <td>${defect.reported_by || 'N/A'}</td>
    </tr>
    `).join('')}
    ${defects.length > 10 ? `<tr><td colspan="5" class="text-center"><i>... and ${defects.length - 10} more defects</i></td></tr>` : ''}
  </tbody>
</table>
` : ''}

${actions.length > 0 ? `
<!-- ACTIONS TAKEN -->
<div class="section-title">ACTIONS TAKEN</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Card</th>
      <th>Date</th>
      <th>Description</th>
      <th>Reported By</th>
    </tr>
  </thead>
  <tbody>
    ${actions.slice(0, 10).map((action, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${action.job_card_id || 'N/A'}</td>
      <td>${action.date || 'N/A'}</td>
      <td>${action.description || 'N/A'}</td>
      <td>${action.reported_by || 'N/A'}</td>
    </tr>
    `).join('')}
    ${actions.length > 10 ? `<tr><td colspan="5" class="text-center"><i>... and ${actions.length - 10} more actions</i></td></tr>` : ''}
  </tbody>
</table>
` : ''}

${jobCards.length > 0 ? `
<!-- JOB CARDS -->
<div class="section-title">JOB CARDS</div>
<table>
  <thead>
    <tr>
      <th>No.</th>
      <th>Card</th>
      <th>Date</th>
      <th>Service Type</th>
      <th>Current Service</th>
      <th>Next Service</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    ${jobCards.slice(0, 10).map((card, i) => `
    <tr>
      <td>${i + 1}</td>
      <td>${card.id || 'N/A'}</td>
      <td>${card.date_created || 'N/A'}</td>
      <td>${card.service_type || '---'}${card.available_costnotes ? ' (' + card.available_costnotes + ')' : ''}</td>
      <td>${card.current_km_of_service || '---'}</td>
      <td>${card.next_km_of_service || '---'}</td>
      <td>${card.status?.name || 'N/A'}</td>
    </tr>
    `).join('')}
    ${jobCards.length > 10 ? `<tr><td colspan="7" class="text-center"><i>... and ${jobCards.length - 10} more job cards</i></td></tr>` : ''}
  </tbody>
</table>
` : ''}

<div style="margin-top: 30px; font-size: 10px; border-top: 1px solid #000; padding-top: 10px;">
  <p><strong>Report Generated:</strong> ${new Date().toLocaleString()}</p>
  <p><strong>Generated By:</strong> ${JSON.parse(localStorage.getItem('user')).name}</p>
</div>

</body>
</html>
`;

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  } catch (error) {
    showError(`Failed to print asset summary: ${error.message}`);
    console.error('Print asset summary error:', error);
  }
};

//21 feb 2026
    const formatComma = (value) => {
  return new Intl.NumberFormat('en-US', { 
    minimumFractionDigits: 1, 
    maximumFractionDigits: 1 
  }).format(value);
};


const refreshButton = (callback = null, status = false) => {

  if (callback) {
    window.__refreshCallback__ = callback;
  }

  return `
  <div class="d-flex">
    <div class="ms-auto mx-5">
      <button 
        class="btn btn-primary rounded-circle p-2 d-flex justify-content-center align-items-center"
        ${callback && !status ? 'onclick="window.__refreshCallback__()"' : ''}
        title="Refresh page"
        style="width: 2.5rem; height: 2.5rem;"
        ${status ? 'disabled' : ''}
      >
        ${
          status 
          ? `<div class="spinner-border text-light" role="status"
               style="width:22px;height:22px;border-width:2px;"></div>`
          : `
            <svg xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
            </svg>
          `
        }
      </button>
    </div>
  </div>
  `;
};

// Provide globally
provide('showMessage', showMessage);
provide('showError', showError);
provide('printReport', printReport);
provide('recordLog', recordLog);
// whatsapp notification injection
provide('whatsappNotification',whatsappNotification);
provide('whatsappNotification2',whatsappNotification2);
// ngugo's injections
provide('DeleteConfirmationbox', showDeleteConfirmation);
provide('SuccessBox', showSuccessbox);
provide('ErrorBox', showErrorBox);
// loading indicator starts
provide('loadingIndicator',loadingIndicator);
// ai icon
provide('aiIndicator',aiIndicator)
//ai answer 
provide('aiAnswer',aiAnswer);
provide('aiAnswer2',aiAnswer2);
provide('deepseek',deepseek);
//18 aug 2025
provide('rowShimmer',rowShimmer)
provide('tableShimmer',tableShimmer)
//19 08 2025
provide('pillShimmer',pillShimmer)
provide('loadingSpinner',loadingSpinner)
//25 august 2025
provide('formatNumber',formatNumber)
//08 september 2025
provide('formatDate',formatDate)
provide('enforceMax',enforceMax)
//18 september 2025
provide('cardShimmer',cardShimmer)
provide('showConfirmation', showConfirmation);
//10 november 2025
provide('whatsappAlert',whatsappAlert)
//17 december 2025
provide('mapShimmer',mapShimmer)
//19 december 2025
provide('waitIndicator',pleaseWait)
//15 jan 2026
provide('printApprovalReport', printApprovalReport);
//16 jan 2026
provide('printStores', printStores);
provide('printStoreItems', printStoreItems);
provide('printRemoteAttendance', printRemoteAttendance);
provide('printSiteLabourAttendance', printSiteLabourAttendance);
//17 jan 2026
provide('printEmployees', printEmployees);
provide('printLabourTypes', printLabourTypes);
provide('printLabourRequests', printLabourRequests);
provide('printApprovals', printApprovals);
provide('printReportMeeting', printReportMeeting);
provide('printAllMeetingsReport', printAllMeetingsReport);
provide('printBoq',printBoq)
provide('printIpc',printIpc)
//20 jan 2026
provide('printProjectPlanning', printProjectPlanning);
provide('printBudgetReport', printBudgetReport);
//21 jan 2026
provide('printEmployeeLeave', printEmployeeLeave);
//22 jan 2026
provide('printLeaveRequests', printLeaveRequests);
//23 jan 2026
provide('printEmployeeList', printEmployeeList);
provide('printBudget', printBudget);
//29 jan 2026
provide('printPendingGrnItemsReport', printPendingGrnItemsReport);

provide('printBinCard', printBinCard);
//20 feb 2026
provide('printProjects', printProjects);
provide('formatComma', formatComma);

//27 feb 2026
provide('refreshButton', refreshButton);
provide('graphShimmer', graphShimmer);

//3rd march 2026
provide('printSparesStatement', printSparesStatement);
provide('printTyresStatement', printTyresStatement);
provide('printDefectsReport', printDefectsReport);
provide('printActionsTaken', printActionsTaken);
provide('printMaintenanceStatement', printMaintenanceStatement);
provide('printFuelStatement', printFuelStatement);
provide('printJobCards', printJobCards);
provide('printAssetSummary', printAssetSummary);



axios.defaults.headers.common["Authorization"] = "Bearer baguvix";

</script>
<script>
    // layouts
    import appLayout from './layouts/app-layout.vue';
    import authLayout from './layouts/auth-layout.vue';

    export default {
        components: {
            app: appLayout,
            auth: authLayout,
        },
    };

    
</script>
